{
  "en": {
    "labels": {
      "saved": "Saved",
      "hangarShare": {
        "intro": "Create a secret link that shows your hangar and its stats to anyone you give it to, even while your hangar is private. Your wishlist keeps its own setting.",
        "howTo": "Anyone with this link can see your hangar. Rotate it to lock out everyone holding the current link, or delete it to stop sharing."
      },
      "locationInput": {
        "linked": "Linked to"
      },
      "galactapedia": "Galactapedia",
      "shopPage": {
        "all": "All",
        "search": "Search this shop",
        "categories": "Categories",
        "sortName": "Name",
        "sortPrice": "Price",
        "emptyName": "item",
        "kind": "Shop",
        "items": "Items",
        "facts": "Key facts",
        "place": "Place",
        "system": "System",
        "carries": "Sells",
        "source": "Prices and stock from UEX."
      },
      "location": {
        "missionsSample": "Counts cover the first %{shown} of %{total}.",
        "people": "Friends & fleet here",
        "peopleFriend": "Friend",
        "peopleUnlisted": "%{count} more not listed",
        "systemUnavailable": "Could not load this system.",
        "systemsUnavailable": "Could not load the systems.",
        "resourceKinds": {
          "ship_mineables": "Ship mineables",
          "hand_mineables": "Hand mineables",
          "ground_vehicle_mineables": "Ground vehicle mineables",
          "harvestables": "Harvestables",
          "creatures": "Creatures"
        },
        "resources": "Resources",
        "moonsBadge": "Moons",
        "planets": "Planets",
        "places": "Places",
        "showFewer": "Show fewer",
        "showAll": "Show all %{count}",
        "elsewhere": "Elsewhere around %{star}",
        "namesakes": "×%{count}",
        "lagrangePoints": "Lagrange points",
        "inOrbit": "In orbit",
        "moons": {
          "one": "%{count} moon",
          "other": "%{count} moons"
        },
        "gateways": "Jump gateways",
        "jumpPoints": "Jump points",
        "notInGameYet": "Not in the game yet",
        "jumpLegend": {
          "title": "Jump connections",
          "inGame": "In game",
          "temporary": "Temporary",
          "planned": "Planned"
        },
        "systemStrip": "%{system}, from its star outward",
        "allSystems": "All Systems",
        "allPlaces": "All places",
        "shops": "Shops",
        "shopItems": {
          "one": "%{count} item",
          "other": "%{count} items"
        },
        "shopItemTypes": {
          "Model": "Ship",
          "ModelModule": "Module",
          "ModelPaint": "Paint",
          "Component": "Component",
          "Equipment": "Equipment",
          "Commodity": "Commodity"
        },
        "bodyTypes": {
          "gas_giant": "Gas giant",
          "ice_giant": "Ice giant",
          "asteroid": "Asteroid",
          "city": "City planet"
        },
        "unstable": "Unstable",
        "unstableHint": "A flare star: its output surges without warning.",
        "systems": "Star systems",
        "name": "Name",
        "kind": "Kind",
        "retired": "Not in this build",
        "starmap": "Star map",
        "starmapVisibility": "In-game map",
        "starmapHidden": "Hidden on the map",
        "starmapAlways": "Always shown on the map",
        "starmapWithParent": "Shown once %{parent} is selected",
        "starmapShown": "Shown on the map",
        "quantumTravel": "Quantum travel",
        "quantumTravelYes": "Yes",
        "quantumTravelNo": "No",
        "mapParent": "Drawn under",
        "mapParentNote": "The in-game map draws it under %{mapParent}, although it sits inside %{parent}.",
        "missions": "Missions",
        "allMissions": "All missions that can take place here",
        "terminals": "Trade terminals",
        "alwaysShown": "Always on the map",
        "hiddenOnStarmap": "Hidden on the map",
        "facilities": "Landing",
        "hangars": "Hangars",
        "hangarsNote": "Each hangar is instanced per pilot: these are doors, not berths.",
        "landingPads": "Landing pads",
        "freeLandingPads": "Free landing pads",
        "freeLandingPadsNote": "Land without ATC assigning the pad.",
        "vehiclePads": "Ground vehicle pads",
        "dockingTubes": "Docking collars",
        "kinds": {
          "system": "Star system",
          "star": "Star",
          "planet": "Planet",
          "moon": "Moon",
          "city": "City",
          "spaceport": "Spaceport",
          "station": "Station",
          "outpost": "Outpost",
          "clinic": "Clinic",
          "district": "District",
          "asteroid": "Asteroid",
          "anomaly": "Anomaly",
          "jump_point": "Jump point",
          "point_of_interest": "Point of interest",
          "nav_point": "Nav point",
          "other": "Other"
        },
        "setLocation": "Set Location",
        "myLocation": "My location",
        "shipLocation": "A ship’s location",
        "setLocationSuccess": "Location updated.",
        "setLocationFailure": "Could not update the location."
      },
      "sortOptions": "Sort Options",
      "loading": "Loading…",
      "loadingNamed": "Loading %{name}…",
      "true": "Yes",
      "false": "No",
      "null": "-",
      "presets": {
        "title": "Choose an image",
        "filter": "Type",
        "all": "All",
        "empty": "No images available."
      },
      "maintainer": {
        "badge": "Maintainer",
        "tooltip": "Maintains FleetYards.net"
      },
      "supporter": {
        "badge": "Supporter",
        "tooltip": "Supports FleetYards.net this month",
        "none": "Not a supporter",
        "fleetTierUntil": "Fleet tier until %{date}",
        "fleetTierExpired": "Expired",
        "fleetTierOngoing": "Fleet tier while the pledge stands",
        "until": "Active until %{date}",
        "expiring": "Expires %{date}",
        "ongoing": "Recurring, no end date",
        "tierShort": "Tier %{tier}"
      },
      "destroyedFleets": {
        "discarded": "Discarded",
        "purged": "Purged"
      },
      "and": "and",
      "hide": "Hide",
      "show": "Show",
      "only": "Only",
      "description": "Description",
      "unavailable": "unavailable",
      "selected": "Selected",
      "actions": "Actions",
      "status": "Status",
      "enabled": "Enabled",
      "disabled": "Disabled",
      "collapse": "Collapse",
      "price": "Price",
      "expand": "Expand",
      "distance": "Distance",
      "anonymous": "Anonymous",
      "refreshing": "Refreshing...",
      "toggleNavigation": "Toggle Navigation",
      "or": "or",
      "groups": "Groups",
      "classifications": "Classifications",
      "features": {
        "stateOn": "Enabled",
        "stateOff": "Disabled",
        "stateConditional": "Conditional",
        "openFor": "Open for %{days} days",
        "historyEmpty": "Nothing recorded for this feature yet.",
        "historyBy": "by %{actor}",
        "sources": {
          "admin": "Admin",
          "self_service": "Self-service",
          "sync": "Deploy",
          "console": "Console",
          "backfill": "Backfilled"
        },
        "selfService": "Self-service",
        "actors": "Actors",
        "groups": "Groups",
        "noGroups": "No groups enabled for this feature.",
        "noActors": "No individual actors enabled for this feature.",
        "user": "User",
        "fleet": "Fleet",
        "actorType": "Actor Type",
        "percentageOfActors": "of actors",
        "percentageOfTime": "of time",
        "currentState": "Current State",
        "toggle": "Toggle",
        "permanent": "Permanent",
        "tabs": {
          "all": "All",
          "rollout": "Rollout",
          "permanent": "Permanent"
        },
        "settingsIntro": "Enable or disable experimental features for your account. These features may be incomplete or change without notice.",
        "registryHint": "Flags are declared in config/feature_flags.yml and created on deploy. Here you control their gates.",
        "fleetSettingsIntro": "Enable or disable features for the whole fleet. Every member sees what you switch on here.",
        "fleetFeature": "Fleet feature",
        "fleetFeatureInfo": "Switching this on here enables it for you alone. Your fleet's admins can enable it for the whole fleet.",
        "toggleForSelf": "Toggle for yourself only",
        "fleetFeatureGrantedShort": "Enabled by fleet",
        "fleetFeatureGranted": "Your fleet enabled this for all members, so it cannot be switched off here.",
        "groupFeatureGrantedShort": "Enabled by group",
        "groupFeatureGranted": "A group you are in has this feature enabled, so it cannot be switched off here.",
        "groupFeatureGrantedFleet": "A group this fleet is in has this feature enabled, so it cannot be switched off here.",
        "managedFeatureShort": "Managed",
        "managedFeature": "This feature was enabled for your account and cannot be changed here.",
        "managedFeatureFleet": "This feature was enabled for this fleet and cannot be changed here.",
        "selfServiceUser": "Users can toggle",
        "selfServiceFleet": "Fleet admins can toggle",
        "globalHint": "On opens the feature to everyone. Off clears every gate, the users, fleets and groups below included.",
        "selfServiceHint": "Who may switch this feature on for themselves.",
        "lastChanged": "Last changed %{date}",
        "filterUsers": "Filter by username",
        "filterFleets": "Filter by name or SID",
        "noUsers": "No user has this feature enabled individually.",
        "noFleets": "No fleet has this feature enabled individually.",
        "noMatches": "Nothing matches the filter.",
        "memberCount": "%{count} members",
        "alreadyEnabled": "This fleet already has the feature."
      },
      "oauthApplication": {
        "name": "Application Name",
        "clientId": "Client ID",
        "clientSecret": "Client Secret",
        "redirectUri": "Redirect URI",
        "redirectUriHint": "Use one URI per line.",
        "confidential": "Confidential",
        "scopes": "Scopes",
        "scopesHint": "If no scopes are selected, the default scopes will be used: %{scopes}",
        "logo": "Logo",
        "logoHint": "Shown on the consent screen so people recognise your application. PNG, JPG, GIF or WebP."
      },
      "rsiRequestLogs": {
        "resolved": "Resolved",
        "unresolved": "Unresolved"
      },
      "imports": {
        "type": "Type",
        "status": "Status",
        "version": "Version",
        "startedAt": "Started",
        "finishedAt": "Finished",
        "failedAt": "Failed at",
        "info": "Info",
        "input": "Input",
        "output": "Output",
        "importData": "Import Data",
        "file": "Imported File",
        "requestedBy": "Requested by",
        "adminUser": "Admin User",
        "user": "User",
        "includeSystem": "Include system",
        "systemRequester": "system",
        "statuses": {
          "created": "Queued",
          "started": "Running",
          "finished": "Finished",
          "failed": "Failed",
          "cancelled": "Cancelled"
        },
        "targetGroupHint": "Pick a hangar group and every imported ship is filed there. Leave it empty to use the groups named in the file.",
        "types": {
          "Imports::HangarImport": "Hangar Import",
          "Imports::HangarSync": "RSI Hangar Sync",
          "Imports::BuybackSync": "RSI Buy-back Sync"
        },
        "summary": {
          "imported": "Imported",
          "missing": "Not found",
          "found": "Matched"
        },
        "formatHint": "Three file formats are accepted:",
        "formats": {
          "fleetyards": "A FleetYards hangar export — use the Export button to create one.",
          "hangarXplor": "A hangarXPLOR export.",
          "hangarExtension": "A JSON export from the Star Citizen: Hangar Extension browser extension."
        },
        "details": {
          "imported": "Added",
          "found": "Matched",
          "movedToWanted": "Moved to wishlist",
          "deleted": "Deleted",
          "grouped": "Filed into a group",
          "unchanged": "Left unchanged",
          "missing": "Ships not found",
          "missingComponents": "Components not found",
          "missingUpgrades": "Upgrades not found"
        },
        "noDetails": "This run recorded no details."
      },
      "oauthApplications": {
        "settingsIntro": "Manage your OAuth applications. These applications can access the FleetYards API on behalf of users.",
        "name": "Application Name",
        "redirectUri": "Redirect URI",
        "confidential": "Confidential",
        "clientId": "Client ID",
        "clientSecret": "Client Secret",
        "scopes": "Scopes",
        "defaultScopes": "Default scopes",
        "confidentialShort": "Confidential",
        "publicShort": "Public",
        "logo": "Logo",
        "state": "Status",
        "rejectionReason": "Reason for refusal",
        "statePending": "Awaiting review",
        "stateApproved": "Approved",
        "stateRejected": "Refused",
        "reviewedBy": "Reviewed by",
        "owner": "Registered by"
      },
      "fleetInviteToken": "Fleet Invite",
      "inviteToken": "Invite code",
      "scDataVersion": "Patch Version",
      "title": "Title",
      "createdAt": "Created at",
      "updatedAt": "Updated at",
      "addToHangar": "Add to Hangar",
      "home": {
        "catalogueSearch": "Search ships, items, missions and places",
        "submitCatalogueSearch": "Search"
      },
      "shop": {
        "sellPrice": "sells for",
        "buyPrice": "buys for"
      },
      "shopCommodity": {
        "item": "Item",
        "shop": "Shop",
        "buyPrices": "Buy Prices",
        "rentalPrices": "Rental Prices",
        "confirmed": "Confirmed?",
        "prices": {
          "label": "Prices",
          "sellPrice": "sells for",
          "buyPrice": "buys for"
        }
      },
      "statsCard": {
        "stock": "Stock: %{value}",
        "more": "+%{count} more on the detail page",
        "unavailable": "Could not load these details.",
        "loading": "Loading %{name}…",
        "offeredBy": "Offered by %{name}",
        "rsiHandle": "RSI handle %{handle}",
        "types": {
          "Component": "Component",
          "Equipment": "Equipment",
          "Commodity": "Commodity",
          "Model": "Ship",
          "Blueprint": "Blueprint",
          "GameMission": "Mission",
          "Location": "Place",
          "FleetContract": "Contract",
          "FleetEvent": "Event",
          "User": "User",
          "FleetMember": "Member"
        },
        "open": {
          "Component": "Open component",
          "Equipment": "Open equipment",
          "Commodity": "Open commodity",
          "Model": "Open ship",
          "Blueprint": "Open blueprint",
          "GameMission": "Open mission",
          "Location": "Open place",
          "FleetContract": "Open contract",
          "FleetEvent": "Open event",
          "User": "Open hangar",
          "FleetMember": "Show in member list"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "New Ships in %{year}",
          "totalShips": "Total Ships",
          "totalMembers": "Total Members",
          "vehicles": "Hangared Ships",
          "wishlists": "Wishlisted Ships",
          "shipOfTheMonth": "Ship of the Month"
        },
        "modelsByClassification": "Ships by Classification",
        "modelsBySize": "Ships by Size",
        "vehiclesByModel": "Ships by Model (Top %{limit})",
        "modelsPerMonth": "Ships per Month",
        "modelsByManufacturer": "Ships by Manufacturer",
        "modelsByProductionStatus": "Ships by Production Status",
        "vehiclesPerMonth": "Hangared Ships per Month",
        "topVehiclesByModel": "Top 10 Hangared Ships",
        "shipsOfTheMonth": "Ship of the Month",
        "trendingShips": "Most Viewed Ships (30 Days)",
        "wishlistByModel": "Most Wishlisted Ships",
        "wishToOwnRatio": "Wished per 100 Owned",
        "topPaints": "Most Popular Paints",
        "paintedVehicles": "Painted Ships",
        "pledgePriceChanges": "Pledge Price Changes (12 Months)",
        "ingamePriceChanges": "In-Game Price Changes (30 Days)",
        "mostWishlisted": "Most Wishlisted This Month",
        "patchChanges": "Most Changed by This Patch",
        "crewDeficit": "Crew Deficit",
        "crewSurplus": "Crew Surplus",
        "membersByRole": "Members by Role",
        "csv": {
          "metric": "Metric",
          "value": "Value",
          "count": "Count"
        }
      },
      "roadmap": {
        "releases": "Releases",
        "released": "Released",
        "lastVersion": {
          "active": {
            "false": "Item was removed from the Roadmap",
            "true": "Item was readded to the Roadmap"
          },
          "released": "Item was released to PU",
          "release": "Item moved from release %{old} to %{new}"
        },
        "stories": {
          "one": "%{count} Story",
          "other": "%{count} Stories"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        }
      },
      "unknown": "Unknown",
      "none": "-",
      "notAvailable": "N/A",
      "not-available": "N/A",
      "name": "Name",
      "homepage": "Homepage",
      "discord": "Discord Server",
      "youtube": "Youtube Channel",
      "twitch": "Twitch Channel",
      "3dView": "3D",
      "3dMap": "Map",
      "texturedHolo": "Textured",
      "texturedHoloOwnPaint": "Standard paint",
      "holoViewer": {
        "background": {
          "dark": "Dark",
          "space": "Space",
          "stanton": "Stanton Nebula",
          "crusader": "Crusader Nebula",
          "pyro": "Pyro Nebula",
          "light": "Light"
        }
      },
      "viewInAr": "AR",
      "viewInArHint": "Place it in your room at true size",
      "filter": "Filter",
      "taxExcluded": "excl. VAT",
      "hangar": "Hangar",
      "public": "Public",
      "hangarStats": "Stats",
      "wishlist": "Wishlist",
      "fleetchart": "Fleetchart",
      "fleetchartScale": "Ship scale",
      "fleetchartApp": {
        "screenHeight": "Screen Height",
        "viewpoint": "Viewpoint",
        "screenHeightOptions": {
          "auto": "Auto",
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "port": "Port",
          "top": "Top",
          "angled": "Angled",
          "front": "Front"
        },
        "gridSize": "%{size} meter per grid box",
        "mode": "Mode",
        "modeOptions": {
          "classic": "Classic",
          "panzoom": "v2"
        }
      },
      "fleetStats": "Stats",
      "hangarMetrics": {
        "total": "Total",
        "totalMoney": "Pledge Value",
        "totalCredits": "In-Game Bought Value",
        "totalIngameValue": "Hangar aUEC Value",
        "totalCrew": "Crew",
        "totalCargo": "Total Cargo",
        "largestShip": "Largest Ship",
        "smallestShip": "Smallest Ship",
        "averagePledgePrice": "Avg. Pledge Price",
        "flightReady": "Flight Ready",
        "uniqueModels": "Unique Models",
        "manufacturerCount": "Manufacturers",
        "missingClassifications": "Missing Roles",
        "wishlistTotalMoney": "Wishlist Pledge Value",
        "wishlistTotalCredits": "Wishlist In-Game Value"
      },
      "selectModel": "Select a Ship",
      "findModel": "Type to find a Ship",
      "find": "Type to search",
      "selectUser": "Select a User",
      "findUser": "Type to find a User",
      "selectAdminUser": "Select an Admin User",
      "selectFleet": "Select a Fleet",
      "findFleet": "Type to find a Fleet",
      "compare": {
        "removeModel": "Remove Ship",
        "addModel": {
          "nullablePrompt": "Add a Ship"
        },
        "enough": "Don't you think 8 Ships are enough? ;)",
        "shipCount": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        },
        "containersOfSize": "%{size} SCU Containers",
        "armorHp": "Armor HP",
        "fuelAndQuantum": "Fuel & Quantum",
        "weaponPoolSize": "Weapon Power Pool",
        "crossSection": {
          "x": "Cross Section X",
          "y": "Cross Section Y",
          "z": "Cross Section Z"
        },
        "useAsBaseline": "Use as baseline",
        "baseline": "Baseline",
        "differencesOnly": "Differences only",
        "compareToBaseline": "Compare to baseline",
        "fastestScraper": "Fastest Scraper",
        "slots": {
          "guns": "Main guns"
        },
        "legend": {
          "best": "best in row",
          "worst": "worst",
          "share": "share of the row's best",
          "better": "beats the baseline",
          "worse": "behind it"
        },
        "selectShips": "Select Ships",
        "componentCount": {
          "one": "%{count} Component",
          "other": "%{count} Components"
        },
        "equipmentCount": {
          "one": "%{count} Item",
          "other": "%{count} Items"
        },
        "remaining": {
          "one": "%{count} more can be added",
          "other": "%{count} more can be added"
        },
        "removeItem": "Remove",
        "selectComponents": "Select Components",
        "selectEquipment": "Select Equipment",
        "enoughItems": "8 items is as many as one comparison holds.",
        "onlyCategory": "Category: %{category}"
      },
      "au": "AU",
      "uec": "aUEC",
      "sell": "Sell",
      "buy": "Buy",
      "yourFlagship": "Your Flagship",
      "flagship": "Flagship",
      "fleet": {
        "headquarters": "Headquarters",
        "index": "Fleet",
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "Fleet",
        "fid": "Fleet ID",
        "name": "Name",
        "logo": "Logo",
        "rsiSid": "SID",
        "rsiSettings": {
          "hint": "The fleet ID is your fleet's address on Fleetyards. The SID links the fleet to its RSI organisation, and verifying it proves the organisation is yours."
        },
        "fidClaim": {
          "claimableTitle": "Claim the fleet ID %{fid}",
          "claimable": "Your fleet is verified for the RSI organisation %{fid}, but another fleet holds the fleet ID %{fid}. If you claim it, that fleet has 14 days to prove the organisation itself or tell its members. Then it is renamed, and %{fid} becomes your fleet ID.",
          "pendingTitle": "Claim on %{fid} pending",
          "pending": "%{holder} keeps %{fid} until %{date}. Then the ID moves to your fleet, unless that fleet proves it runs the organisation %{fid} first.",
          "availableTitle": "The fleet ID %{fid} is free",
          "available": "Your fleet is verified for %{fid}, and no other fleet uses that ID. Set it as your fleet ID above.",
          "incomingTitle": "%{claimant} claims your fleet ID",
          "incoming": "%{claimant} is verified for the RSI organisation **%{fid}**.\n\n**On %{date}:**\n\n- Your fleet moves to the next free fleet ID, such as **%{fid}-1**.\n- Links to %{fid} open %{claimant} from then on.\n\n**To keep the ID**, verify %{fid} before then. Otherwise, let your members know about the new address.",
          "createTakenTitle": "%{fid} is taken",
          "createTaken": "If %{fid} is your RSI organisation, start with %{suggestion} and the SID %{fid}. Once your fleet is verified for %{fid}, it can claim the fleet ID from the fleet that holds it."
        },
        "rsiVerification": {
          "extension": {
            "title": "Verify with the FleetYards Sync extension",
            "verify": "Verify with extension",
            "description": "The extension adds your token to your organisation's history on RSI, publishes it, checks the page, and takes the token out again.",
            "detecting": "Looking for the FleetYards Sync extension",
            "install": "Install the FleetYards Sync extension to verify your fleet in one click.",
            "update": "Update the FleetYards Sync extension to verify your fleet in one click: the installed version does not support it yet.",
            "notSignedIn": "Sign in to RSI in this browser with an account that can edit %{sid}, or verify by hand below.",
            "noRights": "The RSI account signed in to this browser cannot edit %{sid}'s page. Sign in with an officer account, or verify by hand below.",
            "pendingChanges": "%{sid} has unpublished changes on RSI. Publish or erase that draft first, so the extension does not publish someone else's edit, or verify by hand below.",
            "orgUnreadable": "The extension could not read %{sid}'s page on RSI. Verify by hand below.",
            "failed": "The extension could not update %{sid}'s page. Try again, or verify by hand below.",
            "removeFailed": "The extension could not take the token out of %{sid}'s history. Remove it there by hand.",
            "manual": "Or verify by hand:"
          },
          "steps": {
            "copy": "Copy your verification token",
            "paste": "Paste it anywhere on your organisation's public RSI page: the introduction, history, manifesto or charter. You can remove it once the fleet is verified.",
            "check": "Check the page"
          },
          "openOrgPage": "Open %{sid} on RSI",
          "fidAtRiskTitle": "Your fleet ID is not protected",
          "saveFirst": "Save the SID before verifying it.",
          "title": "RSI verification",
          "token": "Verification token",
          "verified": "Verified RSI organisation",
          "unverified": "Not verified with RSI",
          "verifiedSince": "Verified since %{date}",
          "nextCheck": "You can check again in a minute.",
          "fidAtRisk": "Another fleet that verifies the RSI organisation %{fid} can claim it, and your fleet's address changes.",
          "statuses": {
            "pending": "Checking the organisation page…",
            "token_missing": "The token is not on the organisation page yet. RSI can take a few minutes to show an edit.",
            "symbol_mismatch": "The page RSI returned belongs to a different organisation.",
            "not_found": "RSI has no organisation with this SID.",
            "failed": "The organisation page could not be checked. Try again in a minute."
          }
        },
        "description": "Description",
        "public": "Public Fleetview",
        "publicFleet": "Public Fleet",
        "publicStats": "Public Stats",
        "publicFleetStats": "Public Fleet Stats",
        "discord": {
          "url": "Discord Server",
          "hint": "Connect a Discord server to mirror events as native scheduled events. Members can RSVP from Discord and the sign-up will sync back to Fleetyards.",
          "guildId": "Discord Server ID",
          "channelId": "Voice Channel ID (optional)",
          "webhookUrl": "Announcement Webhook URL (optional)",
          "installBotHint": "Opens the Discord install page in a new tab — pick the server you want events mirrored to.",
          "announcementChannel": "Announcement Channel",
          "announcementChannelHint": "New events and starting-soon reminders are posted here. Without one, they go through the webhook. Events held to squadrons are posted in the squadrons' own channels instead. The bot needs View Channel and Send Messages there.",
          "officersChannel": "Officers Channel",
          "officersChannelHint": "Events visible only to officers are announced here and nowhere else on Discord. Without one, they are not announced on Discord at all. Join requests are posted here too, with buttons to accept or decline them. The bot needs View Channel and Send Messages there.",
          "digestWeekday": "Weekly Digest",
          "digestWeekdayHint": "Once a week, every channel gets a list of the coming seven days' events it may see. Leave empty to turn it off.",
          "digestTime": "Digest Time",
          "digestTimeHint": "In your timezone (%{timezone}).",
          "channelMissing": "This channel no longer exists on Discord or can no longer take posts. Nothing is posted until another one is picked.",
          "missingChannel": "Unavailable channel",
          "joinRole": "Join Role",
          "joinRoleHint": "Players holding this role in the server join the fleet without a request, at the default rank. Taking the role away removes the members it brought in. Leave empty to approve every request by hand.",
          "roleMissing": "This role no longer exists on Discord. Nobody joins through it until another one is picked.",
          "missingRole": "Unavailable role",
          "saveGuildFirst": "Save the new server first, then pick its channels and roles.",
          "roleMapping": "Discord Roles",
          "roleMappingHint": "Fleetyards gives members these roles in the server and takes them away when they change rank or leave the fleet. It only ever adds or removes the roles picked here.",
          "memberRole": "Member Role",
          "memberRoleHint": "Every member of the fleet gets this role, whatever their rank.",
          "rolesCodes": {
            "missing_manage_roles": "The bot may not manage roles in this server. Use the install link to re-authorise it.",
            "unknown_role": "A role picked here no longer exists on Discord: %{names}.",
            "role_above_bot": "The bot cannot hand out %{names}: Discord only lets it give roles below its own. Move the bot's role above them in the server settings."
          },
          "eventsCodes": {
            "missing_create_events": "The bot may not create events in this server, so events cannot be pushed to Discord. Give the bot's role Create Events in the server settings, or use the install link to re-authorise it.",
            "voice_channel_locked": "The bot cannot create events in the voice channel set here. Allow it View Channel, Connect and Create Events in that channel's permissions.",
            "unknown_voice_channel": "The voice channel set here no longer exists on Discord or is not a voice channel."
          },
          "postingCodes": {
            "missing_send_messages": "The bot may not send messages in this server. Use the install link to re-authorise it.",
            "channel_locked": "The bot cannot post in the channel picked for %{names}. Allow it View Channel and Send Messages in that channel's permissions.",
            "unknown_channel": "The channel picked for %{names} no longer exists on Discord or can no longer take posts.",
            "channel_shared": "%{names} shares a channel with readers its events are kept from. Nothing is posted there until each has a channel of its own."
          },
          "joinRoleCodes": {
            "members_intent_missing": "The Fleetyards bot may not list this server's members yet, so the join role only takes effect when a player uses an invite link. Contact an administrator.",
            "live_updates_off": "Role changes reach Fleetyards once a day: the bot is not listening for them as they happen. Contact an administrator.",
            "bot_offline": "The Fleetyards bot is not connected to Discord right now, so role changes wait for the daily sweep. Contact an administrator."
          },
          "statusOk": "Connected to %{name}",
          "statusCodes": {
            "missing_token": "The Fleetyards bot is not configured on the server side. Contact an administrator.",
            "missing_guild": "Enter a Discord server ID first.",
            "invalid_token": "The bot token is invalid. Contact an administrator.",
            "bot_not_in_guild": "The bot is not in this server. Use the install link to add it.",
            "guild_not_found": "Discord doesn't recognize this server ID. Double-check the value.",
            "discord_error": "Discord returned an unexpected error.",
            "request_failed": "Could not reach Fleetyards. Try again."
          }
        },
        "homepage": "Homepage",
        "twitch": "Twitch Channel",
        "youtube": "Youtube Channel",
        "backgroundImage": "Background Image",
        "ts": "Teamspeak Server",
        "awaitingConfirmation": "Awaiting confirmation by Fleet",
        "members": {
          "verifiedOrgMember": "Verified member of %{sid}",
          "verifiedOrgMemberChecked": "Verified member of %{sid}, checked %{checked}",
          "primary": "Primary Fleet?",
          "shipsFilter": {
            "label": "Which Ships should be added to the Fleet?",
            "nullablePrompt": "No Option selected",
            "field": "Ships Select",
            "values": {
              "all": "All Ships",
              "hangar_group": "All Ships in a given Hangar Group",
              "hide": "No Ships"
            }
          },
          "hangarGroupId": {
            "field": "Hangar Group",
            "label": "Specify a Hangar Group",
            "nullablePrompt": "No Group selected"
          },
          "blueprintsFilter": {
            "label": "Which Blueprints should be shared with the Fleet?",
            "nullablePrompt": "No Option selected",
            "field": "Blueprints Select",
            "values": {
              "all": "All Blueprints I own",
              "hide": "No Blueprints"
            }
          },
          "total": "Total: %{count}",
          "rsiTotal": "On RSI: %{count}",
          "joined": "Joined at",
          "invited": "Invited",
          "invitedAt": "Invited / Requested at",
          "requested": "Membership Requested",
          "declined": "Declined",
          "pending": "Pending Invites & Requests",
          "accepted": "Members",
          "role": "Role",
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord",
          "views": {
            "members": "Members",
            "invites": "Invites"
          },
          "health": {
            "overview": "Checks",
            "summary": {
              "attention": {
                "one": "%{count} of %{total} checks needs attention",
                "other": "%{count} of %{total} checks need attention"
              },
              "clear": "All %{total} checks are clear"
            },
            "groups": {
              "leadership": "Leadership",
              "rsi": "RSI organisation",
              "activity": "Activity",
              "requests": "Requests and invites",
              "integrations": "Integrations"
            },
            "days": {
              "one": "%{count} day",
              "other": "%{count} days"
            },
            "checks": {
              "admins": {
                "title": "Admins",
                "overview": "Admins",
                "clear": "%{admins} members hold Admin."
              },
              "unverified": {
                "title": "Not verified against %{sid}",
                "overview": "Not verified",
                "description": "A member is verified when their own RSI organisation list names %{sid}. Each row says why that could not be confirmed.",
                "clear": "Every member is verified against %{sid}."
              },
              "noHandle": {
                "title": "No RSI handle",
                "overview": "No RSI handle",
                "clear": "Every member has given an RSI handle."
              },
              "inactive": {
                "title": "Inactive members",
                "overview": "Inactive %{count}+ days",
                "clear": "Everyone was active in the last %{count} days."
              },
              "joinRequests": {
                "title": "Join requests waiting over a week",
                "overview": "Old join requests",
                "clear": "No join request has waited more than a week."
              },
              "invitations": {
                "title": "Invitations nobody answered",
                "overview": "Unanswered invites",
                "clear": "No invitation has been open for more than two weeks."
              },
              "inviteUrls": {
                "title": "Invite links to tidy up",
                "overview": "Invite links",
                "clear": "Every invite link is in use."
              },
              "discord": {
                "title": "Not linked to Discord",
                "overview": "Discord",
                "clear": "Every member has Discord linked."
              },
              "emptySquadrons": {
                "title": "Squadrons nobody is in",
                "overview": "Empty squadrons",
                "clear": "Every squadron has members."
              },
              "noSquadron": {
                "title": "Members in no squadron",
                "overview": "No squadron",
                "clear": "Every member is in a squadron."
              },
              "hiddenShips": {
                "title": "Ships kept out of the fleet",
                "overview": "Hidden hangars",
                "clear": "Every member shares their ships with the fleet."
              }
            },
            "facts": {
              "joined": "Joined %{date}",
              "lastActive": "Last active %{distance}",
              "neverActive": "Never active",
              "checked": "Checked %{distance}",
              "requested": "Requested %{distance}",
              "invited": "Invited %{distance}",
              "invitedBy": "Invited by %{name}",
              "noDiscord": "No Discord account linked",
              "noSquadron": "No squadron",
              "noHandle": "No handle given",
              "linkExpired": "Expired %{distance}",
              "linkUsedUp": "No uses left",
              "createdBy": "Created by %{name}",
              "used": {
                "one": "Used once",
                "other": "Used %{count} times"
              },
              "team": "Team",
              "created": "Created %{date}",
              "linkUnused": "Never used, created %{distance}"
            },
            "gaps": {
              "no_handle": "No RSI handle on profile",
              "handle_unverified": "RSI handle not verified",
              "orgs_not_checked": "Org list not read yet",
              "org_not_listed": "%{sid} not on their org list"
            },
            "orgStats": {
              "rsi": "%{sid} on RSI",
              "roster": "On FleetYards",
              "gap": "Never joined here"
            },
            "fleetNotVerified": "%{sid} itself is not verified yet, so no member shows as verified anywhere else.",
            "singleAdmin": "If %{name} leaves or loses access, nobody can manage %{fleet} on FleetYards.",
            "hiddenShips": {
              "one": "%{count} member keeps their hangar out of the fleet's ship list.",
              "other": "%{count} members keep their hangar out of the fleet's ship list."
            },
            "deleteLinkFailed": "The invite link could not be deleted.",
            "noAdmin": "Nobody holds Admin, so nobody can manage %{fleet} on FleetYards.",
            "adminCandidates": "Promote to Admin",
            "addedToSquadron": {
              "success": "Added to the squadron.",
              "failure": "Could not be added to the squadron."
            },
            "reminded": {
              "success": "Reminder sent.",
              "failure": "The reminder could not be sent."
            },
            "remindedAt": "Reminded %{distance}. You can remind again a week later."
          },
          "card": {
            "verified": "Verified",
            "unverified": "Not verified",
            "squadrons": "Squadrons"
          }
        },
        "squadrons": {
          "index": "Squadrons",
          "name": "Name",
          "shortDescription": "Short description",
          "shortDescriptionHint": "A line or two, shown on the card",
          "description": "Description",
          "descriptionHint": "The full text on the squadron's own page",
          "noDescription": "No description has been added yet.",
          "icon": "Icon",
          "iconHint": "Square image, shown as a circle",
          "team": "Team",
          "teamHint": "A team is open to everyone — otherwise a member belongs to one squadron",
          "restrictedToHint": "Only these squadrons can see it",
          "discordChannel": "Discord Channel",
          "discordChannelHint": "Events held to this squadron are announced here and nowhere else on Discord. Without a channel, they are not announced on Discord at all. The bot needs View Channel and Send Messages there.",
          "notAnnounced": "Not announced on Discord for %{names}: no Discord channel is set up.",
          "blockedBy": "Already in the %{squadron} squadron",
          "color": "Color",
          "colorSuggestions": "From the icon:",
          "memberCount": "%{count} Members",
          "members": "Members",
          "joinedAt": "Squadron joined at",
          "searchMembers": "Search Members",
          "availableMembers": "available Members",
          "selectedMembers": "%{count} selected",
          "rank": "Rank",
          "ranksHint": "The names every squadron in this fleet uses. Renaming a rank keeps its place and what it may do.",
          "rankName": "Name",
          "defaultRank": "Default",
          "defaultRankToggle": "New members start on this rank",
          "rankRights": {
            "singleHolder": "One per squadron",
            "managesMembers": "Adds and removes the members ranked below",
            "managesRanks": "Sets the ranks below their own"
          },
          "views": {
            "members": "Members",
            "requests": "Requests"
          },
          "requestedAt": "Asked on",
          "requests": "Requests"
        },
        "roles": {
          "permanent": "Permanent",
          "default": "Default",
          "defaultToggle": "New members get this role",
          "privilegeGroups": {
            "fleet": "Fleet",
            "memberships": "Members",
            "squadrons": "Squadrons",
            "invites": "Invites",
            "vehicles": "Vehicles",
            "blueprints": "Blueprints",
            "roles": "Roles",
            "inventories": "Inventories",
            "shopping_lists": "Shopping Lists",
            "missions": "Missions",
            "events": "Events",
            "allies": "Allies",
            "contracts": "Contracts",
            "payouts": "Payouts",
            "notifications": "Notifications",
            "announcements": "Announcements"
          },
          "privileges": {
            "fleet:update": "Update Fleet",
            "fleet:update:images": "Update Images",
            "fleet:update:description": "Update Description",
            "fleet:delete": "Delete Fleet",
            "fleet:manage": "Manage Fleet",
            "fleet:memberships:read": "View Members",
            "fleet:memberships:create": "Invite Members",
            "fleet:memberships:update": "Update Members",
            "fleet:memberships:delete": "Remove Members",
            "fleet:memberships:manage": "Manage Members",
            "fleet:squadrons:read": "View Squadrons",
            "fleet:squadrons:create": "Create Squadrons",
            "fleet:squadrons:update": "Update Squadrons",
            "fleet:squadrons:delete": "Delete Squadrons",
            "fleet:squadrons:members:manage": "Manage Squadron Members",
            "fleet:squadrons:manage": "Manage Squadrons",
            "fleet:invites:read": "View Invites",
            "fleet:invites:create": "Create Invites",
            "fleet:invites:update": "Update Invites",
            "fleet:invites:delete": "Delete Invites",
            "fleet:invites:manage": "Manage Invites",
            "fleet:vehicles:read": "View Vehicles",
            "fleet:vehicles:create": "Add Vehicles",
            "fleet:vehicles:update": "Update Vehicles",
            "fleet:vehicles:delete": "Remove Vehicles",
            "fleet:vehicles:manage": "Manage Vehicles",
            "fleet:blueprints:read": "View Blueprints",
            "fleet:roles:read": "View Roles",
            "fleet:roles:create": "Create Roles",
            "fleet:roles:update": "Update Roles",
            "fleet:roles:delete": "Delete Roles",
            "fleet:roles:manage": "Manage Roles",
            "fleet:inventories:read": "View Inventories",
            "fleet:inventories:create": "Create Inventories",
            "fleet:inventories:update": "Update Inventories",
            "fleet:inventories:delete": "Delete Inventories",
            "fleet:inventories:manage": "Manage Inventories",
            "fleet:shopping_lists:read": "View Shopping Lists",
            "fleet:shopping_lists:create": "Publish Shopping Lists",
            "fleet:shopping_lists:update": "Update Shopping Lists",
            "fleet:shopping_lists:delete": "Delete Shopping Lists",
            "fleet:shopping_lists:manage": "Manage Shopping Lists",
            "fleet:missions:read": "View Missions",
            "fleet:missions:create": "Create Missions",
            "fleet:missions:update": "Update Missions",
            "fleet:missions:delete": "Delete Missions",
            "fleet:missions:manage": "Manage Missions",
            "fleet:events:read": "View Events",
            "fleet:events:create": "Create Events",
            "fleet:events:update": "Update Events",
            "fleet:events:delete": "Delete Events",
            "fleet:events:manage": "Manage Events",
            "fleet:allies:read": "View Allies",
            "fleet:allies:create": "Add Allies",
            "fleet:allies:delete": "Remove Allies",
            "fleet:allies:manage": "Manage Allies",
            "fleet:contracts:read": "View Contracts",
            "fleet:contracts:create": "Create Contracts",
            "fleet:contracts:update": "Update Contracts",
            "fleet:contracts:delete": "Delete Contracts",
            "fleet:contracts:manage": "Manage Contracts",
            "fleet:payouts:read": "View Payouts",
            "fleet:payouts:create": "Record Payouts",
            "fleet:payouts:update": "Update Payouts",
            "fleet:payouts:delete": "Delete Payouts",
            "fleet:payouts:manage": "Manage Payouts",
            "fleet:notifications:manage": "Manage Notification Settings",
            "fleet:announcements:manage": "Manage Announcements"
          },
          "name": "Name",
          "rank": "Rank"
        },
        "inviteUrls": {
          "noExpiration": "Never expires",
          "used": "Used %{count} times",
          "usedOfLimit": "Used %{count} of %{limit}",
          "expiresIn": "Expires in %{time}",
          "expired": "Expired",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 day",
            "7_days": "7 days"
          },
          "limitOptions": {
            "infinite": "No limit",
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses"
          }
        },
        "calendarSubscription": {
          "intro": "Generate a private link that members can use to subscribe to this fleet's events from their calendar app (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Share the link above with your members. They paste it into their calendar app (\"Subscribe to calendar\" or \"Add by URL\"). The link is private — anyone with it can see this fleet's events."
        },
        "notifications": {
          "inAppHint": "Pick which event lifecycle changes show up as in-app notifications for fleet members.",
          "events": {
            "fleet_event": {
              "published": "Event published",
              "locked": "Sign-ups locked",
              "unlocked": "Sign-ups reopened",
              "starting_soon": "Event starting soon",
              "started": "Event started",
              "completed": "Event completed",
              "cancelled": "Event cancelled",
              "archived": "Event archived",
              "destroyed": "Event deleted"
            },
            "fleet_event_signup": {
              "created": "Signup added",
              "withdrawn": "Signup withdrawn"
            }
          }
        },
        "inventories": {
          "name": "Name",
          "description": "Description",
          "location": "Location",
          "visibility": "Visibility",
          "manager": "Manager",
          "itemsCount": "Entries",
          "visibilities": {
            "members_only": "Members only",
            "officers_only": "Officers only",
            "squadron_only": "Squadron only"
          }
        },
        "allies": "Ships visible to allies",
        "alliesStats": "Stats visible to allies",
        "alliesMembers": "Member list visible to allies",
        "squadronsEnabled": "Use squadrons",
        "listed": "Show in the fleet directory",
        "listedInfo": "A verified, public fleet with at least two members can be found in the fleet directory. A private fleet is never listed.",
        "alignment": "Alignment",
        "alignments": {
          "lawful": "Lawful",
          "neutral": "Neutral",
          "outlaw": "Outlaw"
        },
        "activities": {
          "bounty_hunting": "Bounty Hunting",
          "engineering": "Engineering",
          "exploration": "Exploration",
          "freelancing": "Freelancing",
          "infiltration": "Infiltration",
          "medical": "Medical",
          "piracy": "Piracy",
          "resources": "Resources",
          "scouting": "Scouting",
          "security": "Security",
          "smuggling": "Smuggling",
          "social": "Social",
          "trading": "Trading",
          "transport": "Transport"
        },
        "commitments": {
          "casual": "Casual",
          "regular": "Regular",
          "hardcore": "Hardcore"
        },
        "rsiProfile": {
          "info": "Synced from your organisation's RSI page once a day. Change these on RSI.",
          "primaryActivity": "Primary activity",
          "secondaryActivity": "Secondary activity",
          "language": "Language",
          "commitment": "Commitment",
          "recruiting": "Recruiting",
          "roleplay": "Role play"
        },
        "contractCovers": {
          "transport": "Transport cover",
          "procurement": "Procurement cover",
          "crafting": "Crafting cover"
        }
      },
      "hangarGroup": {
        "name": "Name",
        "color": "Color",
        "sort": "Sort Order",
        "public": "Show on Public Hangar?"
      },
      "source": "Source",
      "loadout": {
        "marker": "Loadout \"%{name}\"",
        "fleetyards": "Fleetyards loadout",
        "namePlaceholder": "Loadout name...",
        "urlPlaceholder": "Paste erkul.games or spviewer.eu loadout URL...",
        "activateHint": "Click to make this the active loadout",
        "activeHint": "This is the active loadout",
        "kinds": {
          "fleetyards": "Fleetyards",
          "erkul": "Erkul",
          "spviewer": "SPViewer",
          "link": "Link"
        },
        "public": "Public",
        "private": "Private",
        "empty": "No loadouts yet. Create one to get started.",
        "active": "Active",
        "activate": "Set Active"
      },
      "model": {
        "hidden": "Hidden?",
        "active": "Active?",
        "inGame": "In Game?",
        "adiMap": "ADI Map?",
        "ground": "Ground Vehicle?",
        "productionNote": "Production Note",
        "rsiId": "RSI ID",
        "length": "Length",
        "beam": "Beam",
        "height": "Height",
        "scKey": "SC Key",
        "price": "Price",
        "pledgePrice": "Pledge Price",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "Mass",
        "crew": "Crew",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Max Speed",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "Cargo",
        "cargoHolds": "Cargo Holds",
        "keepCargo": "Keep this cargo figure instead of the game-file holds",
        "hydrogenFuelTankSize": "Hydrogen Fuel Tank Size",
        "hydrogenFuelTanks": "Hydrogen Fuel Tanks",
        "quantumFuelTankSize": "Quantum Fuel Tank Size",
        "quantumFuelTanks": "Quantum Fuel Tanks",
        "externalFuelTanks": "External Fuel Tanks",
        "orePods": "Ore Pods",
        "weaponRacks": "Weapon Racks",
        "medicalBedsTier": "Tier %{tier} medical beds",
        "medicalBedsNamed": "%{name} medical beds",
        "respawnBeds": "Respawn beds",
        "salvageStorage": "Salvage Storage",
        "externalFuelTanksTotal": "Total Capacity",
        "externalFuelTanksCount": "Pods",
        "refuelBoom": "Refueling Boom",
        "refuelBoomArm": "Arm",
        "refuelBoomNozzle": "Nozzle",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Yaw Boosted",
        "pitchBoosted": "Pitch Boosted",
        "rollBoosted": "Roll Boosted",
        "variants": "Variants",
        "manufacturer": "Manufacturer",
        "loaners": "Loaners",
        "paints": "Paints",
        "modules": "Modules",
        "modulePackages": "Module Packages",
        "upgrades": "Upgrade-Kits",
        "brochure": "Brochure",
        "holo": "Holo",
        "angledView": "Angled View",
        "angledViewColored": "Angled View Colored",
        "portView": "Port View",
        "portViewColored": "Port View Colored",
        "frontView": "Front View",
        "frontViewColored": "Front View Colored",
        "topView": "Top View",
        "topViewColored": "Top View Colored",
        "onSale": "On Sale",
        "playerOwnable": "Player Ownable?",
        "ccuOverride": "CCUs",
        "ccuOverrides": {
          "allowed": "RSI sells CCUs into and out of it",
          "none": "RSI sells no CCUs for it"
        },
        "ccuEvidence": {
          "onSale": "On sale in the store today",
          "into": "CCU into it first seen %{date}",
          "outOf": "CCU out of it first seen %{date}",
          "none": "No CCU seen in any store, hangar or buy-back"
        },
        "ingameOnly": "In-game only",
        "stealth": "Stealth",
        "rsiFocus": "RSI: %{value}",
        "scRole": "Game files: %{value}",
        "canLandOnPlanets": "Can land on planets",
        "cannotLandOnPlanets": "Can't land on planets",
        "salesPage": "Sales Page",
        "addons": "Modules & Upgrade-Kits",
        "storeImage": "Store Image",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "Crew Positions",
        "needsCuration": "Needs Curation",
        "curatedPosition": "Manually curated position",
        "baseModel": "Base Model",
        "fleetchartOffsetLength": "Fleetchart Offset Length",
        "fleetchartOffsetBeam": "Fleetchart Offset Beam",
        "extendedLength": "Extended Length",
        "extendedBeam": "Extended Beam",
        "extendedHeight": "Extended Height",
        "extendedFleetchartOffsetLength": "Extended Fleetchart Offset Length",
        "extendedFleetchartOffsetBeam": "Extended Fleetchart Offset Beam",
        "defaultHolo": "Default Holo",
        "extendedHolo": "Extended Holo",
        "extendedTopView": "Extended Top View",
        "extendedTopViewColored": "Extended Top View Colored",
        "extendedPortView": "Extended Port View",
        "extendedPortViewColored": "Extended Port View Colored",
        "extendedFrontView": "Extended Front View",
        "extendedFrontViewColored": "Extended Front View Colored",
        "extendedAngledView": "Extended Angled View",
        "extendedAngledViewColored": "Extended Angled View Colored",
        "landedHolo": "Landed Holo",
        "landedTopView": "Landed Top View",
        "landedPortView": "Landed Port View",
        "landedFrontView": "Landed Front View",
        "landedAngledView": "Landed Angled View",
        "landedTopViewColored": "Landed Top View Colored",
        "landedPortViewColored": "Landed Port View Colored",
        "landedFrontViewColored": "Landed Front View Colored",
        "landedAngledViewColored": "Landed Angled View Colored",
        "angledRearView": "Angled Rear View",
        "angledRearViewColored": "Angled Rear View Colored",
        "bottomView": "Bottom View",
        "bottomViewColored": "Bottom View Colored",
        "rearView": "Rear View",
        "rearViewColored": "Rear View Colored",
        "starboardView": "Starboard View",
        "starboardViewColored": "Starboard View Colored",
        "extendedAngledRearView": "Extended Angled Rear View",
        "extendedAngledRearViewColored": "Extended Angled Rear View Colored",
        "extendedBottomView": "Extended Bottom View",
        "extendedBottomViewColored": "Extended Bottom View Colored",
        "extendedRearView": "Extended Rear View",
        "extendedRearViewColored": "Extended Rear View Colored",
        "extendedStarboardView": "Extended Starboard View",
        "extendedStarboardViewColored": "Extended Starboard View Colored",
        "landedAngledRearView": "Landed Angled Rear View",
        "landedAngledRearViewColored": "Landed Angled Rear View Colored",
        "landedBottomView": "Landed Bottom View",
        "landedBottomViewColored": "Landed Bottom View Colored",
        "landedRearView": "Landed Rear View",
        "landedRearViewColored": "Landed Rear View Colored",
        "landedStarboardView": "Landed Starboard View",
        "landedStarboardViewColored": "Landed Starboard View Colored",
        "holoLite": "Lite Holo",
        "extendedHoloLite": "Extended Lite Holo",
        "landedHoloLite": "Landed Lite Holo",
        "holoTextured": "Textured Holo",
        "holoTexturedLite": "Textured Lite Holo",
        "landedHoloTextured": "Landed Textured Holo",
        "landedHoloTexturedLite": "Landed Textured Lite Holo",
        "holoHull": "Hull Holo",
        "holoUsdz": "AR Holo (USDZ)",
        "state": {
          "flight": "In Flight",
          "extended": "Extended",
          "landed": "Landed"
        },
        "productionStatus": {
          "in-production": "In Production",
          "in-concept": "In Concept",
          "ready": "Hangar Ready",
          "flight-ready": "Flight Ready",
          "announced": "Announced"
        },
        "carriedBy": "Can be carried by",
        "landedLength": "Landed length",
        "landedBeam": "Landed beam",
        "landedHeight": "Landed height",
        "landedFleetchartOffsetLength": "Landed Fleetchart Offset Length",
        "landedFleetchartOffsetBeam": "Landed Fleetchart Offset Beam",
        "owners": {
          "title": "In your circle",
          "yourShips": "Your ships",
          "friends": "Friends",
          "fleets": "Your fleets",
          "more": "+%{count} more",
          "empty": "Nobody you know has one yet.",
          "fleetShips": {
            "one": "%{count} ship",
            "other": "%{count} ships"
          }
        }
      },
      "models": {
        "extraColumns": "Columns",
        "table": {
          "columns": {
            "storeImage": "Image",
            "storeImageWide": "Wide Image",
            "rsiStoreImage": "RSI Image",
            "rsiStoreImageWide": "Wide RSI Image",
            "angledView": "3D Image",
            "angledViewWide": "Wide 3D Image",
            "rsiId": "RSI ID",
            "hidden": "Hidden",
            "active": "Active",
            "createdAt": "Created At",
            "updatedAt": "Updated At",
            "manufacturerName": "Manufacturer",
            "length": "Length",
            "beam": "Beam",
            "height": "Height",
            "mass": "Mass",
            "cargo": "Cargo",
            "quantumFuelTankSize": "Quantum Fuel",
            "hydrogenFuelTankSize": "Hydrogen Fuel",
            "crew": "Crew",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "Max Speed",
            "groundMaxSpeed": "Ground Speed",
            "focus": "Focus",
            "productionStatus": "Production Status",
            "price": "Price",
            "pledgePrice": "Pledge Price"
          }
        }
      },
      "metrics": {
        "info": "Info",
        "levels": "Levels",
        "views": "Views",
        "base": "Base",
        "crew": "Crew",
        "speed": "Speed",
        "cargo": "Cargo",
        "combat": "Combat",
        "hardpoints": "Hardpoints"
      },
      "flight": {
        "boostCapacitor": "Boost Capacitor",
        "boostCapacity": "Capacity",
        "boostRegen": "Regen",
        "boostRegenDelay": "Regen Delay",
        "boostRamp": "Ramp Up / Down",
        "title": "Flight",
        "scm": "combat cruise",
        "nav": "cruise",
        "boost": "Boost",
        "boostSub": "afterburner",
        "reverse": "Reverse",
        "maneuverability": "Maneuverability",
        "fuel": "Fuel",
        "fuelHydrogen": "Hydrogen",
        "fuelQuantum": "Quantum",
        "fuelBurnMain": "Burn, mains",
        "fuelBurnAll": "Burn, all",
        "fuelDrawMain": "Draw, mains",
        "fuelDrawAll": "Draw, all",
        "durationHoursMinutes": "%{hours} h %{minutes} min",
        "durationMinutes": "%{minutes} min"
      },
      "base": {
        "price": "Price",
        "priceInGame": "In-game",
        "pricePledge": "Pledge",
        "availability": "Availability"
      },
      "availability": {
        "title": "Availability",
        "buy": "Buy",
        "rent": "Rent",
        "sell": "Sell",
        "cheapest": {
          "buy": "Cheapest buy",
          "rent": "Cheapest rent"
        },
        "bestSale": "Best sale price",
        "allLocations": "All locations",
        "locations": {
          "one": "%{count} location",
          "other": "%{count} locations"
        },
        "empty": "No known buy or rental locations.",
        "timeRange": {
          "1-day": "1 day",
          "3-days": "3 days",
          "7-days": "7 days",
          "30-days": "30 days"
        }
      },
      "cargo": {
        "title": "Cargo",
        "holdsSub": "across %{count} holds",
        "maxContainerSub": "largest box it takes",
        "containers": "Container Capacity",
        "boxCount": {
          "one": "%{count} × %{size} SCU box",
          "other": "%{count} × %{size} SCU boxes"
        }
      },
      "weaponRacks": {
        "slots": "Slots",
        "racks": "Racks",
        "categories": {
          "weapon": "Weapon",
          "gadget": "Gadget",
          "cargo": "Cargo",
          "carriable": "Carriable",
          "armor": "Armor",
          "other": "Other"
        },
        "size": "S%{size}",
        "sizeRange": "S%{min}–S%{max}",
        "sizeUpTo": "up to S%{size}",
        "only": "%{tag} only",
        "tags": {
          "multitool": "Multi-Tool",
          "medical_injection": "Med Pens",
          "grenade": "Grenades"
        }
      },
      "storageContainers": {
        "total": "Total Capacity",
        "count": "Containers",
        "perContainer": "each"
      },
      "fuelTanks": {
        "capacitySub": "across %{count} pods",
        "podsSub": "external mounts",
        "components": "Pod Types",
        "perPod": "per pod"
      },
      "salvageMetrics": {
        "heads": "Salvage Heads",
        "largestCrate": "Largest Crate",
        "fillTime": "%{time} s per SCU to fill",
        "fillTimeLabel": "Fill Time",
        "fieldSupporters": "Field Supporters",
        "fracture": "Fracture",
        "disintegration": "Disintegration",
        "reach": "up to %{radius} m · %{time} s/m",
        "yield": "Yield",
        "yieldValue": "%{amount} SCU/m³ %{resource}",
        "alignment": "Alignment Bonus",
        "alignmentValue": "up to %{speed}× speed · %{yield}× yield"
      },
      "refuelBoom": {
        "fuelFlowSub": "hydrogen transfer",
        "quantumFlowSub": "quantum transfer",
        "captureRadiusSub": "docking tolerance",
        "equipment": "Equipment"
      },
      "combat": {
        "title": "Combat",
        "openPenetrationCheck": "Penetration check",
        "dps": "Burst DPS",
        "dpsSub": "%{count} weapons",
        "sustained": "Sustained",
        "sustainedSub": "with regen & heat",
        "alpha": "Alpha",
        "alphaSub": "per volley",
        "weapons": "Weapons",
        "missileDamage": "Missile Damage",
        "armedMissiles": "Armed Missiles",
        "armedMissilesSub": "%{cooldown} s between launches",
        "composition": "Damage Composition",
        "damagePhysical": "Physical",
        "damageEnergy": "Energy",
        "damageDistortion": "Distortion",
        "damageThermal": "Thermal",
        "controlComposition": "DPS by Control",
        "controlGroups": {
          "pilot": "Pilot",
          "manned": "Manned Turret",
          "remote": "Remote Turret",
          "pds": "Point Defense"
        }
      },
      "power": {
        "planner": {
          "sustained": "%{dps} DPS sustained",
          "weaponPower": "weapon power %{percent}",
          "weaponsOff": "Weapons offline",
          "regen": "%{regen} HP/s regen",
          "shieldsDown": "Shields down",
          "engineOff": "Engine unpowered",
          "engineOffSub": "no flight at all",
          "boostedHandling": "Boosted handling %{percent}",
          "engineBase": "Base thrust only",
          "engineBaseSub": "boost needs more segments",
          "radarOff": "Radar dark",
          "coolant": "%{rate} coolant per second",
          "noCooling": "No cooling",
          "ready": "Ready to spool",
          "off": "Off",
          "needsBlock": "needs its block of %{min} to start",
          "powered": "Powered",
          "segments": "Segments in use",
          "signatures": "Signatures",
          "plantSegments": "%{segments} segments",
          "segmentsTotal": "segments",
          "setPips": "%{name}: %{count} segments",
          "weaponEnergy": "Weapon energy",
          "energyGun": "Energy · fires from its capacitor",
          "heatGun": "Ballistic · limited by heat",
          "sustainedEach": "sustained, each",
          "capacitor": "Capacitor",
          "shots": "%{count} of %{max} shots",
          "firing": "Time on the trigger",
          "emptiesIn": "Empties in",
          "overheatsIn": "Overheats in",
          "refillsIn": "Refills in",
          "recoversIn": "Recovers in",
          "regenLabel": "Regen",
          "shotsPerSecond": "%{rate} shots/s",
          "presets": {
            "title": "Presets",
            "name": "Preset name",
            "save": "Save preset",
            "rename": "Rename %{name}",
            "delete": "Delete %{name}",
            "add": "Add preset"
          },
          "title": "Power planner",
          "titleFor": "Power planner · %{name}",
          "open": "Power planner"
        },
        "title": "Power Distribution",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "Reset",
        "auto": "Auto",
        "aimAssist": "Aim Assist",
        "cooling": "Cooling",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "Click to switch axis (x / y / z)",
        "segmentsUsed": "%{used} / %{total} segments",
        "families": {
          "weapon": "Weapons",
          "shield": "Shields",
          "engine": "Engine",
          "radar": "Radar",
          "coolers": "Coolers",
          "qdrive": "Quantum Drive",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "Life Support",
          "miningLaser": "Mining Laser",
          "salvage": "Salvage",
          "tractorBeam": "Tractor Beam",
          "towingbeam": "Towing Beam"
        }
      },
      "defense": {
        "title": "Defense",
        "shieldHp": "Shield HP",
        "shieldHpSub": "%{count} generators",
        "shieldRegen": "Regeneration",
        "shieldResistances": "Resistance",
        "shieldAbsorption": "Absorption",
        "shieldFaces": "Shield Faces",
        "armor": "Armor",
        "deflection": "Deflection",
        "armorReduction": "Damage reduction",
        "armorSelfResistance": "Self resistance",
        "armorSignature": "Signature",
        "countermeasures": "Countermeasures",
        "countermeasureDuration": "Duration",
        "countermeasure": {
          "decoy": "Decoy",
          "noise": "Noise"
        },
        "damageType": {
          "physical": "Phys",
          "energy": "Energy",
          "distortion": "Distort",
          "thermal": "Thermal"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "openDeflectionCheck": "Deflection check"
      },
      "penetrationCheck": {
        "title": "Penetration Check",
        "intro": "— which ships can its guns pierce?",
        "noWeapons": "This loadout mounts no guns with per-shot damage to test.",
        "weapons": "Weapons",
        "shieldHealth": "Target shield health",
        "armorHealth": "Target armor health",
        "ship": "Ship",
        "hoverHint": "Hover a ship for the per-weapon breakdown.",
        "note": "Each selected gun is tested against every ship's shields and armor deflection with the same rules as the deflection check; a ship is pierced when any one of them gets through, and ranked by the gun that comes closest. Ships without armor are left out, since there is no threshold to cross.",
        "sortBy": "Sort by",
        "sort": {
          "margin": "Margin",
          "ttk": "Time to kill"
        },
        "ttk": "TTK",
        "effectiveHp": "Effective HP",
        "shieldsDown": "Shields down",
        "ttkNote": "Time to kill uses the selected guns' sustained damage per second, under the current power allocation, from the shield and armor health set above. Shields take the damage they absorb, less their resistance, and pass the rest to the armor, which takes it until it breaks and then hands it to the hull; distortion only ever drains shields. Shields regenerate only while every gun is paused for longer than their regen delay, and once down they stay down. Effective HP is the raw damage of one type it takes to destroy the ship, without deflection. Beams, marked TTK, count towards the time to kill only: armor never deflects them, and with no per-shot alpha they take no part in the margin. Missiles are left out."
      },
      "deflectionCheck": {
        "title": "Deflection Check",
        "intro": "— which guns pierce its defenses?",
        "noArmor": "This ship carries no armor, so nothing is deflected.",
        "allSizes": "All",
        "deflected": "deflected",
        "pierce": "pierce",
        "weapon": "Weapon",
        "boundary": "Deflection boundary",
        "alpha": "Alpha",
        "threshold": "Threshold crossed",
        "absorbed": "absorbed",
        "versus": "vs",
        "hoverHint": "Hover a weapon for the per-type breakdown.",
        "note": "Alpha is compared per pellet, after the shield's soak — a gun pierces when it beats the deflection on any damage type. Types the shields absorb completely never reach the armor, so they are listed as absorbed rather than deflected: stopped by the shield, not the hull. Shield absorption interpolates across its published min–max range by shield health, and armor deflection scales linearly with armor health. Laser beams are excluded — they deal continuous damage, so there is no per-shot alpha to test.",
        "margin": "Margin",
        "reachesArmor": "Reaches armor",
        "stoppedByShields": "Shield absorbs",
        "verdict": {
          "absorbed": "Absorbed",
          "deflected": "Deflected",
          "pierces": "Pierced"
        },
        "shieldHealth": "Shield health",
        "armorHealth": "Armor health",
        "absorb": "Absorb",
        "defl": "Defl",
        "type": "Type",
        "size": "Size"
      },
      "hull": {
        "category": {
          "vital": "Vital",
          "secondary": "Secondary",
          "breakable": "Breakable",
          "subpart": "Subparts",
          "cosmetic": "Cosmetic"
        },
        "composition": "Hull Composition",
        "door": "Door",
        "doors": "Doors",
        "doorsNote": "Breakable interior doors are a separate area — they carry their own health and are not part of hull HP.",
        "doorsSub": "%{count} breakable",
        "hullHp": "Hull HP",
        "hullHpSub": "total across all parts",
        "integrity": "Hull Integrity",
        "noHp": "no HP",
        "parts": "Hull Parts",
        "partsNote": "Parts are ranked by health; cosmetic parts (doors, ladders, flaps) carry no health of their own. The game files expose no parent/child links, so this is a flat list rather than a structural tree.",
        "partsSub": "across %{count} categories",
        "partsTree": "Parts · damageMax",
        "showParts": "Show hull parts",
        "title": "Hull",
        "totalHp": "Total Hull HP"
      },
      "manufacturer": {
        "shortName": "Short name",
        "shipyard": "Shipyard",
        "longName": "Long Name",
        "code": "Code",
        "logo": "Logo",
        "logoOverridden": "Logo (overridden)",
        "icon": "Icon (game files)",
        "iconOverridden": "Icon (overridden)",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "Title",
        "body": "Body",
        "discordParts": "Discord messages",
        "socialParts": "Social posts",
        "link": "Link",
        "notifyUsers": "In-app notification",
        "postDiscord": "Discord updates channel",
        "postBluesky": "Bluesky",
        "schedule": "Schedule",
        "publishAt": "Send at"
      },
      "fundingGoal": {
        "title": "Title",
        "description": "Description",
        "amount": "Amount",
        "currency": "Currency",
        "effectiveFrom": "Effective from",
        "endedAt": "Ended at"
      },
      "homepageSetting": {
        "featuredModelsInfo": "Shown beside the homepage search. Leave empty to draw from every ship with a coloured angled render.",
        "featuredHidden": "Show no featured ship",
        "featuredHiddenInfo": "The hero stays centred, with no ship beside it.",
        "featuredRandom": "Pick at random",
        "featuredRandomInfo": "Each day features one of these ships, the same for every visitor. Off: always the first ship in the list."
      },
      "gameEvent": {
        "title": "Title",
        "description": "Description",
        "location": "Location",
        "url": "Link",
        "category": "Category",
        "startsAt": "Starts at",
        "endsAt": "Ends at",
        "coverImage": "Cover image",
        "published": "Published",
        "publishedInfo": "Only published events appear on the homepage."
      },
      "supporterContribution": {
        "name": "Supporter Name",
        "user": "Linked Account",
        "amount": "Amount",
        "currency": "Currency",
        "anonymous": "Anonymous",
        "recurring": "Recurring",
        "oneTime": "One-time",
        "public": "Public",
        "sourceUnspecified": "Unspecified",
        "startedAt": "Started at",
        "endedAt": "Ended at",
        "payerEmail": "Payer email",
        "claimKey": "Supporter token",
        "linkedVia": "Linked via",
        "source": "Source",
        "note": "Internal note",
        "stats": {
          "total": "Total",
          "count": "Contributions",
          "currentMonth": "This Month",
          "currentMonthCount": "%{count} contributions",
          "recurringCount": "Recurring",
          "anonymousCount": "Anonymous"
        },
        "chart": {
          "contributions": "Contributions",
          "goal": "Goal"
        }
      },
      "itemPrice": {
        "price": "Price",
        "location": "Location",
        "locationUrl": "Location URL"
      },
      "video": {
        "url": "URL",
        "videoType": "Type"
      },
      "modelModule": {
        "slot": "Slot",
        "noSlot": "No slot",
        "slotsOnHull": "Module slots on this hull: %{slots}",
        "noSlotsOnHull": "The game files give this hull no module slots; any name can be set",
        "name": "Name",
        "description": "Description",
        "price": "Price",
        "pledgePrice": "Pledge Price",
        "productionStatus": "Production Status",
        "scKey": "SC Key",
        "cargo": "Cargo",
        "storeImage": "Store Image",
        "active": "Active?",
        "hidden": "Hidden?"
      },
      "dockAddition": {
        "model": "Ship",
        "hint": "Ships this berth takes that its class does not cover.",
        "empty": "named ships"
      },
      "dockCapacity": {
        "ladder": "Ladder",
        "size": "Class",
        "quantity": "How many",
        "display": "Show as the label",
        "hint": "What the berth is built for. Entries are alternatives, not a sum.",
        "empty": "capacity entries"
      },
      "dockCapacityLadders": {
        "ship": "Ships",
        "vehicle": "Vehicles"
      },
      "vehicleSizes": {
        "extra_extra_small": "Extra Extra Small (XXS)",
        "extra_small": "Extra Small (XS)",
        "small": "Small (S)",
        "medium": "Medium (M)",
        "large": "Large (L)",
        "extra_large": "Extra Large (XL)",
        "extra_extra_large": "Extra Extra Large (XXL)"
      },
      "dock": {
        "name": "Name",
        "dockType": "Dock Type",
        "shipSize": "Ship Size",
        "access": "Access",
        "length": "Length",
        "beam": "Beam",
        "height": "Height",
        "unmeasured": "not measured"
      },
      "modelPosition": {
        "name": "Name",
        "positionType": "Position Type",
        "source": "Source",
        "position": "Sort Order",
        "types": {
          "pilot": "Pilot",
          "copilot": "Co-pilot",
          "turret_gunner": "Turret gunner",
          "engineer": "Engineer",
          "gunner": "Gunner",
          "loadmaster": "Loadmaster",
          "passenger": "Passenger",
          "operator": "Operator",
          "custom": "Custom"
        }
      },
      "modelUpgrade": {
        "name": "Name",
        "description": "Description",
        "pledgePrice": "Pledge Price",
        "active": "Active?",
        "hidden": "Hidden?"
      },
      "modelModulePackage": {
        "name": "Name",
        "description": "Description",
        "pledgePrice": "Pledge Price",
        "modules": "Modules",
        "active": "Active?",
        "hidden": "Hidden?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "Rotation (°)",
        "maxLoadableContainerSizeScu": "Largest loadable crate"
      },
      "modelLoaner": {
        "hidden": "Hidden?",
        "loanerModel": "Loaner Model"
      },
      "modelSnubCraft": {
        "snubCraft": "Snub Craft"
      },
      "modelPaint": {
        "hidden": "Hidden?",
        "active": "Active?",
        "onSale": "On Sale",
        "pledgePrice": "Pledge Price",
        "productionStatus": "Production Status",
        "productionNote": "Production Note",
        "copyHint": "Select the target ship to copy this paint to. The paint data is not modified during the copy.",
        "bulkCopyHint": "Select the target ship to copy these %{count} paints to. The paint data is not modified during the copy.",
        "copySameModel": "Target ship must differ from the source ship."
      },
      "component": {
        "temperature": {
          "minCooling": "Cooling From",
          "overheat": "Overheats At",
          "warning": "Warning At",
          "recovery": "Recovers At",
          "misfireRange": "Misfire Range",
          "irStart": "IR From",
          "irPerKelvin": "IR per K"
        },
        "misfire": {
          "heat": "Heat",
          "distortion": "Distortion",
          "damage": "Damage",
          "wear": "Wear",
          "window": "Window",
          "hint": "The level of each stat at which the component can start to misfire, as the game files give it."
        },
        "availability": {
          "retired": "Prices are tracked for the build the catalogue is on, and this part is not in it.",
          "craftedOnly": "No terminal sells this — it is made from the recipe below.",
          "none": "No terminal buys or sells this."
        },
        "notRecordedYet": "Only recorded from the day this started, so a component can have none yet.",
        "size": "Size: %{size}",
        "grade": "Grade",
        "hidden": "Hidden?",
        "componentType": "Component Type",
        "componentSubType": "Component Sub Type",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "itemClass": "Class",
        "category": "Category",
        "subType": "Sub Type",
        "retired": "No longer in the current build",
        "noMetrics": "No metrics are recorded for this component.",
        "integrity": "Integrity",
        "durability": {
          "health": "Health",
          "mass": "Mass",
          "physical": "Physical",
          "energy": "Energy",
          "distortion": "Distortion",
          "thermal": "Thermal",
          "biochemical": "Biochemical",
          "stun": "Stun",
          "repairTime": "Repair time",
          "repairsTo": "Repairs to",
          "maxRepairs": "Max repairs",
          "disableAt": "Disabled at",
          "warningAt": "Warning at",
          "recoversBelow": "Recovers below",
          "decayRate": "Decay rate",
          "decayDelay": "Decay delay"
        },
        "durabilityChanges": {
          "health": "Health",
          "mass": "Mass (kg)",
          "resistancesPhysical": "Physical damage taken",
          "resistancesEnergy": "Energy damage taken",
          "resistancesDistortion": "Distortion damage taken",
          "resistancesThermal": "Thermal damage taken",
          "resistancesBiochemical": "Biochemical damage taken",
          "resistancesStun": "Stun damage taken",
          "selfRepairTime": "Self-repair time (s)",
          "selfRepairHealthRatio": "Self-repair restores to",
          "selfRepairMaxRepairs": "Max self-repairs",
          "distortionMaximum": "Distortion shutdown threshold",
          "distortionWarningRatio": "Distortion warning threshold",
          "distortionRecoveryRatio": "Distortion recovery threshold",
          "distortionDecayRate": "Distortion decay rate (/s)",
          "distortionDecayDelay": "Distortion decay delay (s)"
        }
      },
      "hardpoint": {
        "legend": {
          "headline": "Legend",
          "slotTaken": "Slot taken",
          "slotAvailable": "Slot available"
        },
        "size": "Size",
        "rackSize": "Rack Size",
        "details": "Details",
        "group": "Group",
        "thrusters": {
          "thrust": "Thrust",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix",
            "Light": "Light"
          },
          "fuelBurn": "Fuel Burn",
          "mode": "Mode",
          "vtolOnly": "VTOL only",
          "vectorPitch": "Vectoring Pitch",
          "vectorYaw": "Vectoring Yaw"
        },
        "refuelBoom": {
          "captureRadius": "Capture Radius",
          "fuelFlowRate": "Fuel Flow Rate",
          "quantumFuelFlowRate": "Quantum Fuel Flow Rate"
        },
        "controllers": {
          "faceType": "Shield Type",
          "faces": {
            "bubble": "Bubble",
            "quadrant": "Quadrant"
          },
          "reconfigurationCooldown": "Reconfiguration",
          "armedMissiles": "Armed Missiles",
          "launchCooldown": "Launch Cooldown",
          "lockAngle": "Lock Angle"
        },
        "countermeasureStats": {
          "duration": "Duration",
          "spawnDelay": "Deploys After",
          "infrared": "IR Signature",
          "electromagnetic": "EM Signature",
          "crossSection": "Cross Section"
        },
        "turrets": {
          "turnRate": "Turn Rate",
          "control": "Control",
          "yawRange": "Yaw Range",
          "pitchRange": "Pitch Range",
          "limitsVary": "varies with rotation",
          "gunPorts": "Gun Ports"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "Burst DPS",
          "sustainedDps": "Sustained DPS",
          "efficiency": "Efficiency",
          "penetration": "Penetration",
          "fireRate": "Fire Rate",
          "speed": "Speed",
          "range": "Range",
          "ammo": "Ammo",
          "ammoCost": "Ammo Cost",
          "magazineDamage": "Magazine Damage",
          "timeToEmpty": "Time to Empty",
          "spread": "Spread",
          "spreadFirstShot": "First Shot Spread",
          "spreadPerShot": "Spread/Shot",
          "spreadRecovery": "Spread Recovery",
          "pool": "Capacitor",
          "maxRegen": "Max Regen/s",
          "costPerShot": "Energy/Shot",
          "heatPerShot": "Heat/Shot",
          "heatPerSecond": "Heat/s",
          "gimbalFireRate": "Fire Rate (Gimbal)",
          "gimbalSpread": "Spread (Gimbal)",
          "spreadMin": "min",
          "spreadMax": "max",
          "aimAssist": "Aim Assist",
          "closeAimAssist": "Close-Range Assist",
          "chargeTime": "Charge Time",
          "fullDamageRange": "Full DMG Range",
          "zeroDamageRange": "Zero DMG Range",
          "damagePhysical": "Physical",
          "damageEnergy": "Energy",
          "damageDistortion": "Distortion",
          "damageThermal": "Thermal"
        },
        "missiles": {
          "damage": "Damage",
          "speed": "Speed",
          "range": "Range",
          "lockRange": "Lock Range",
          "lockTime": "Lock Time",
          "trackingSignal": "Tracking",
          "lockAngle": "Lock Cone",
          "signalResilience": "Signal Resilience",
          "boostPhase": "Boost Phase",
          "terminalPhase": "Terminal Phase",
          "lifetime": "Lifetime",
          "fuel": "Fuel",
          "dumbfire": "Dumbfire",
          "dumbfireAllowed": "Allowed",
          "dumbfireBlocked": "Not allowed",
          "blastRadius": "Blast Radius",
          "armTime": "Arm Time",
          "safetyDistance": "Safety Distance"
        },
        "bombs": {
          "maxDropAngle": "Max Drop Angle"
        },
        "missileRacks": {
          "launchDelay": "Launch Delay",
          "ignition": "Motor Ignition",
          "ignitesOnRack": "On the rack",
          "ignitesAfterRelease": "After release"
        },
        "tractorBeams": {
          "maxForce": "Max Force",
          "minForce": "Min Force",
          "range": "Range",
          "cone": "Cone",
          "tetherBreak": "Tether Break",
          "cargoForce": "Cargo Force",
          "cargoRange": "Cargo Range",
          "towForce": "Tow Force",
          "towDistance": "Tow Range",
          "quantumTowMass": "QT Mass Limit",
          "rotationSpeed": "Rotation",
          "moveSpeed": "Move Speed"
        },
        "shields": {
          "hp": "HP",
          "regen": "Regen",
          "regenTime": "Regen Time",
          "downedRegenDelay": "Downed Delay",
          "damagedRegenDelay": "Damaged Delay",
          "resistancePhysical": "Phys. Resist.",
          "resistanceEnergy": "Energy Resist.",
          "resistanceDistortion": "Dist. Resist.",
          "decay": "Decay",
          "absorption": {
            "physical": "Physical Absorption",
            "energy": "Energy Absorption",
            "distortion": "Distortion Absorption"
          }
        },
        "coolers": {
          "coolingRate": "Cooling Rate"
        },
        "powerPlants": {
          "output": "Output",
          "pips": "Pips"
        },
        "flightControllers": {
          "scmSpeed": "SCM Speed",
          "boostSpeed": "Boost Speed",
          "navSpeed": "Nav Speed",
          "rotation": "Pitch / Yaw / Roll",
          "boostedRotation": "Boosted Pitch / Yaw / Roll",
          "boostCapacity": "Boost Capacity",
          "boostRegen": "Boost Regen",
          "boostRegenDelay": "Boost Regen Delay",
          "boostRamp": "Boost Ramp Up / Down"
        },
        "quantumDrives": {
          "speed": "Speed",
          "range": "Range",
          "fuelConsumption": "Consumption",
          "spoolUpTime": "Spool Up",
          "cooldownTime": "Cooldown",
          "splineSpeed": "Orbit",
          "accel": "Accel",
          "engageSpeed": "Engage Speed",
          "calibrationRate": "Calibration Rate",
          "disconnectRange": "Disconnect Range",
          "interdictionTime": "Interdiction Time",
          "splineAccel": "Orbit Accel",
          "splineSpoolUpTime": "Orbit Spool Up",
          "splineCooldownTime": "Orbit Cooldown",
          "splineInterdictionTime": "Orbit Interdiction",
          "jumpHeat": "Jump Heat"
        },
        "jumpDrives": {
          "fuelEfficiency": "Fuel Efficiency",
          "alignRate": "Align Rate",
          "tuneRate": "Tune Rate",
          "alignDecay": "Align Decay",
          "tuneDecay": "Tune Decay",
          "exitSpeed": "Exit Speed",
          "maxTunnelSpeed": "Max Tunnel Speed",
          "respoolTime": "Respool"
        },
        "radar": {
          "aimAssistRange": "Assist Range",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS",
          "passive": "Passive Detection",
          "active": "Active Detection",
          "aimAssistBuffer": "Assist Buffer",
          "sensitivityModifier": "Sensitivity Modifier",
          "contactGroups": {
            "GroundVehicle": "Ground Vehicles"
          }
        },
        "armor": {
          "hp": "HP",
          "physical": "Physical",
          "energy": "Energy",
          "distortion": "Distortion",
          "thermal": "Thermal",
          "deflectPhysical": "Phys Deflect",
          "deflectEnergy": "Energy Deflect",
          "selfPhysical": "Self-Res Phys",
          "selfEnergy": "Self-Res Energy"
        },
        "fuelIntakes": {
          "pushRate": "Push Rate",
          "minRate": "Min Rate"
        },
        "sources": {
          "game_files": "Game Files",
          "ship_matrix": "Ship Matrix"
        },
        "fuelTanks": {
          "hydrogen": "Hydrogen Fuel Tank",
          "quantum": "Quantum Fuel Tank"
        },
        "jumpDrive": "Jump Drive",
        "maxContainerSize": "Max. Container Size",
        "groups": {
          "avionic": "Avionics",
          "system": "Systems",
          "propulsion": "Propulsion",
          "thruster": "Thruster",
          "weapon": "Weapons",
          "defense": "Defense",
          "other": "Cargo",
          "auxiliary": "Auxiliary",
          "seat": "Seats",
          "external_fuel_tank": "External Fuel Tanks",
          "ore_pod": "Ore Pods",
          "mining": "Mining",
          "module": "Modules",
          "salvage": "Salvage",
          "salvage_storage": "Salvage Storage",
          "refuel_boom": "Refuel Boom"
        },
        "types": {
          "radar": "Radar",
          "computers": "Computers",
          "power_plants": "Power Plants",
          "coolers": "Coolers",
          "shield_generators": "Shield Generators",
          "fuel_intakes": "Fuel Intakes",
          "fuel_tanks": "Fuel Tanks",
          "quantum_drives": "Quantum Drives",
          "jump_modules": "Jump Modules",
          "jumpdrive": "Jump Modules",
          "quantum_fuel_tanks": "Quantum Fuel Tanks",
          "main_thrusters": "Main Thrusters",
          "maneuvering_thrusters": "Maneuvering Thrusters",
          "weapons": "Weapons",
          "turrets": "Turrets",
          "missiles": "Missiles",
          "utility_items": "Utility Items",
          "utility": "Utility Items",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— Select Module —",
        "selectModule": "Select Module",
        "moduleStock": "As delivered",
        "moduleStockHint": "Slot left as the ship comes",
        "categories": {
          "radar": "Radar",
          "armor": "Armor",
          "relay": "Relay",
          "countermeasures": "Countermeasures",
          "lifesupport": "Life Support",
          "selfdestruct": "Self Destruct",
          "batteries": "Batteries",
          "computers": "Computers",
          "powerplant": "Power Plants",
          "cooler": "Coolers",
          "module": "Modules",
          "shieldgenerator": "Shield Generators",
          "fuel_intakes": "Fuel Intakes",
          "fueltanks": "Fuel Tanks",
          "external_fuel_tanks": "External Fuel Tanks",
          "ore_pods": "Ore Pods",
          "salvage_storage": "Salvage Storage",
          "refuel_boom": "Refuel Boom",
          "quantumdrive": "Quantum Drives & Jump Modules",
          "jump_modules": "Jump Modules",
          "jumpdrive": "Jump Modules",
          "quantum_fuel_tanks": "Quantum Fuel Tanks",
          "main_thrusters": "Main Thrusters",
          "maneuvering_thrusters": "Maneuvering Thrusters",
          "retro_thrusters": "Retro Thrusters",
          "vtol_thrusters": "VTOL Thrusters",
          "weapons": "Weapons",
          "weapon_mounts": "Weapon Mounts",
          "turret": "Turrets",
          "missiles": "Missiles",
          "missile_racks": "Missile Racks",
          "utility_items": "Utility Items",
          "utility": "Utility Items",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "Salvage Filler Station",
          "bombs": "Bombs",
          "mining_lasers": "Mining Lasers",
          "mining_modules": "Mining Modules",
          "salvage_heads": "Salvage Heads",
          "salvage_modules": "Salvage Modules",
          "tractor_beams": "Tractor Beams",
          "cargogrid": "Cargo Grid",
          "controller": "Flight Blades",
          "seat": "Seats",
          "thrusters": "Thrusters",
          "bombcompartments": "Bomb Compartments",
          "paints": "Paints"
        },
        "name": "Name",
        "category": "Category",
        "source": "Source",
        "powerConsumption": "Power Draw",
        "powerMinimumFraction": "Idle Draw",
        "signatureEm": "EM Signature",
        "signatureIr": "IR Signature",
        "mining": {
          "fracturePower": "Fracture Power",
          "extractionPower": "Extraction Power",
          "range": "Range",
          "chargeTime": "Charge Up / Down",
          "moduleSlots": "Module Slots",
          "activation": "Type",
          "active": "Active",
          "passive": "Passive",
          "charges": "Uses",
          "duration": "Duration",
          "modifiers": {
            "instability": "Instability",
            "resistance": "Resistance",
            "optimalChargeWindow": "Optimal Charge Window",
            "optimalChargeRate": "Optimal Charge Rate",
            "catastrophicChargeRate": "Catastrophic Charge Rate",
            "shatterDamage": "Shatter Damage",
            "inertMaterials": "Inert Materials",
            "clusterFactor": "Cluster Factor"
          }
        },
        "salvage": {
          "salvageSpeed": "Salvage Speed",
          "radius": "Beam Radius",
          "extractionEfficiency": "Extraction Efficiency"
        },
        "utility": {
          "capacity": "Capacity"
        },
        "selfDestruct": {
          "damage": "Damage",
          "radius": "Blast Radius",
          "time": "Fuse Time"
        },
        "quantumEnforcement": {
          "jammerRange": "Jammer Range",
          "pulseRadius": "Pulse Radius",
          "chargeTime": "Charge Time",
          "cooldownTime": "Cooldown"
        },
        "emp": {
          "distortionDamage": "Distortion Damage",
          "radius": "Radius",
          "chargeTime": "Charge Time",
          "unleashTime": "Unleash Time",
          "cooldownTime": "Cooldown"
        },
        "lifeSupport": {
          "output": "Output"
        },
        "powerRanges": "Power Curve (Low / Med / High)",
        "powerSegments": "seg"
      },
      "blank": {
        "propulsion": "No Propulsion present",
        "modular": "No Modular present",
        "fleetInvites": "No Invites present"
      },
      "user": {
        "displayName": "Display name",
        "displayNameInfo": "Shown instead of your username in your public hangar, on your dedication plaques and in fleet rosters.",
        "hangarDefaultSort": "Default Order",
        "hangarDefaultSortInfo": "Drag a ship by its grip to reorder. Shows while the custom order is active and no filter is set.",
        "hangarDefaultSortOptions": {
          "standard": "Standard (flagship first, then name)",
          "asc": "%{field}, ascending",
          "desc": "%{field}, descending"
        },
        "rsiHandle": "Handle",
        "rsiHandleVerified": "Verified via Citizen iD",
        "rsiHandleVerifiedViaProfile": "Verified via RSI profile",
        "rsiVerification": {
          "title": "Verify your RSI handle",
          "token": "Verification token",
          "verifiedSince": "Verified since %{date}",
          "revokeCitizenidQuestion": "Back at next Citizen iD sign-in. Sure?",
          "openProfileSettings": "Edit your RSI profile",
          "steps": {
            "copy": "Copy your verification token",
            "paste": "Paste it into the short bio on your RSI profile. You can remove it once your handle is verified.",
            "check": "Check the citizen page of %{handle}"
          },
          "extension": {
            "title": "Verify with the FleetYards Sync extension",
            "verify": "Verify with extension",
            "description": "The extension adds your token to the bio of the RSI account this browser is signed in to, checks your citizen page, and takes the token out again.",
            "detecting": "Looking for the FleetYards Sync extension",
            "install": "Install the FleetYards Sync extension to verify your handle in one click.",
            "update": "Update the FleetYards Sync extension to verify your handle in one click: the installed version does not support it yet.",
            "handleMismatch": "This browser is signed in to RSI as %{rsiHandle}, not %{handle}. Sign in to RSI as %{handle}, or verify by hand below.",
            "notSignedIn": "Sign in to RSI in this browser to verify with the extension, or verify by hand below.",
            "bioTooLong": "Your RSI bio is too long to add the token. Shorten it, or verify by hand below.",
            "bioUnreadable": "Your RSI bio has formatting the extension cannot keep as it is. Verify by hand below.",
            "failed": "The extension could not update your RSI bio. Try again, or verify by hand below.",
            "removeFailed": "The extension could not take the token out of your RSI bio. Remove it there by hand.",
            "manual": "Or verify by hand:"
          },
          "statuses": {
            "pending": "Checking your citizen page…",
            "token_missing": "The token is not in your bio yet. RSI can take a few minutes to show an edit.",
            "handle_mismatch": "The page RSI returned belongs to a different handle.",
            "not_found": "RSI has no citizen with this handle.",
            "failed": "Your citizen page could not be checked. Try again in a minute."
          }
        },
        "location": "Location",
        "currentSystem": "Current In-Game Location",
        "tester": "Tester?",
        "maintainer": "Maintainer?",
        "avatar": "Avatar",
        "unconfirmedEmail": "Unconfirmed email",
        "saleNotify": "I want to receive Sale Notifications",
        "publicHangar": "Public Hangar enabled",
        "publicHangarLoaners": "Show Loaners Hint on Public Hangar",
        "publicHangarStats": "Public Hangar Stats enabled",
        "publicWishlist": "Public Wishlist enabled",
        "hideOwner": "Hide Ownership for Fleets",
        "tracking": "Allow anonymous usage analytics",
        "showOnlineStatus": "Show when I am online",
        "supporterListed": "Supporters page",
        "supporterListedPlatform": "As chosen when donating",
        "supporterListedShown": "Show my username",
        "supporterListedHidden": "Don't show me",
        "onlineStatus": "Online status",
        "online": "Online",
        "offline": "Offline",
        "lastActiveAt": "Last Active",
        "confirmedAt": "Confirmed at",
        "dateFormat": "Date format",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        },
        "friendsHangar": "Hangar visible to friends",
        "friendsHangarStats": "Hangar stats visible to friends",
        "friendsWishlist": "Wishlist visible to friends"
      },
      "adminUser": {
        "superAdmin": "Super Admin",
        "passwordConfirmation": "Password Confirmation"
      },
      "vehicle": {
        "cargoWithModules": "%{cargo} (%{withModules} with modules)",
        "customOrder": "Custom",
        "name": "Name",
        "states": "States",
        "serial": "Serial",
        "owner": "commanded by",
        "flagship": "Flagship",
        "wanted": "Wanted",
        "loaner": "Loaner",
        "bundled": "Bundled",
        "bundledWith": "Bundled with %{parent}",
        "hiddenByUser": "Hidden from your Hangar",
        "public": "Public Visible",
        "fullPublic": "Public Visible including Name",
        "private": "Not Public Visible",
        "publicShort": "Public",
        "saleNotifyOn": "Sale notifications on",
        "saleNotifyOff": "Sale notifications off",
        "nameVisible": "Public Visible",
        "hidden": "Hidden?",
        "saleNotify": "I want to receive Sale Notifications",
        "hangarGroups": "Groups",
        "ownedPaintsSelect": {
          "label": "Owned paints",
          "pledged": "From a pledge",
          "empty": "No paints found"
        },
        "modelPaintSelect": {
          "nullablePrompt": "Select a Paint",
          "label": "Paint"
        },
        "bulkGroupEdit": {
          "hint": "Existing Groups will be overridden!"
        },
        "hasLoaners": "Loaners",
        "boughtViaSelect": {
          "label": "Bought via"
        }
      },
      "image": {
        "active": "Active?",
        "background": "Use as Background?",
        "caption": "Caption",
        "enabled": "Enabled?",
        "file": "Image File",
        "global": "Global?",
        "delete": "Delete",
        "start": "Start",
        "cancel": "Cancel",
        "processing": "Processing...",
        "error": "Error",
        "name": "Name",
        "size": "File size",
        "dropzone": "Drop images here",
        "cancelUpload": "Cancel upload",
        "startUpload": "Start upload",
        "selectImages": "Add images...",
        "selectFolder": "Add a folder..."
      },
      "signup": {
        "link": "Don't have an Account?",
        "privacyPolicy": "By creating a FleetYards account, you agree to our"
      },
      "privacyPolicy": "Privacy Policy",
      "login": "Username or email",
      "username": "Username",
      "twoFactorCode": "Two-factor code",
      "confirmationCode": "Confirmation code",
      "email": "Email",
      "avatar": "Avatar",
      "alreadyRegistered": "Already have an Account?",
      "password": "Password",
      "passwordConfirmation": "Password Confirmation",
      "rememberMe": "Remember me",
      "emptyList": "No %{name} present",
      "all": "All",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted.",
        "calendarSubscription": {
          "intro": "Generate a private link to add the events you've signed up for to your personal calendar app (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Paste the link into your calendar app under \"Subscribe to calendar\" or \"Add by URL\". Anyone with this link can see the events you're signed up for — keep it private."
        },
        "supporterNomination": {
          "label": "Fleet support",
          "hint": "Its members get the fleet features while a donation is active. You can choose before donating.",
          "perDonation": "Per donation",
          "perDonationHint": "A donation can support a different fleet from your usual one.",
          "fleet": "Supported fleet"
        },
        "supporterClaimKey": {
          "signedOut": "Please log in to get your personal supporter key.",
          "patreonNote": "matched by your email, no key needed",
          "label": "Your key",
          "hint": "Paste it into the message on a PayPal, Ko-fi or Buy me a coffee payment and it links to your account. Patreon matches you by email instead.",
          "listed": "Whether your username appears on the supporters page is up to you:",
          "listedLink": "Privacy settings"
        }
      },
      "filters": {
        "locations": {
          "name": "Search locations",
          "system": "System",
          "parent": "Inside",
          "kind": "Kind",
          "starmap": "In-game map",
          "shownOnStarmap": "Shown on the map",
          "hiddenOnStarmap": "Hidden on the map"
        },
        "components": {
          "name": "Name",
          "buyPriceGt": "Buy Price >=",
          "buyPriceLt": "Buy Price <=",
          "sellPriceGt": "Sell Price >=",
          "sellPriceLt": "Sell Price <=",
          "storeImageBlank": "Without Store Image?",
          "description": "Description",
          "manufacturer": "Manufacturer",
          "category": "Category",
          "subType": "Sub Type",
          "size": "Size",
          "grade": "Grade"
        },
        "shops": {
          "name": "Name",
          "type": "Type",
          "model": "Ship",
          "equipment": "Equipment",
          "component": "Component",
          "commodity": "Commodity",
          "commodityType": "Commodity Type"
        },
        "shopCommodities": {
          "commodityType": "Commodity Type",
          "equipment": "Equipment",
          "component": "Component",
          "commodity": "Commodity",
          "model": "Ship",
          "name": "Name"
        },
        "shopItems": {
          "category": "Category",
          "subCategory": "Sub Category",
          "name": "Name",
          "manufacturer": "Manufacturer"
        },
        "stations": {
          "name": "Name",
          "type": "Station Type",
          "shops": "Shops",
          "docks": "Docks"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "cargoGt": "SCU >=",
          "cargoLt": "SCU <=",
          "maxWeaponSizeGt": "Largest gun >=",
          "maxWeaponSizeLt": "Largest gun <=",
          "alphaGt": "Alpha >=",
          "alphaLt": "Alpha <=",
          "burstDpsGt": "Burst DPS >=",
          "burstDpsLt": "Burst DPS <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Price <=",
          "priceGt": "Price >=",
          "wanted": "Wanted",
          "hidden": "Hidden",
          "public": "Public",
          "group": "Group",
          "loaner": "Loaners",
          "bundled": "Bundled Snub Crafts",
          "hiddenByUser": "Hidden Ships",
          "boughtVia": "Bought via?",
          "image": "Image",
          "imageSources": {
            "custom": "Any non-default",
            "upload": "Uploaded",
            "gallery": "From gallery",
            "default": "Default"
          },
          "dedication": "Dedication Plaque"
        },
        "models": {
          "name": "Name",
          "cargoGt": "SCU >=",
          "cargoLt": "SCU <=",
          "classification": "Classification",
          "focus": "Focus",
          "manufacturer": "Manufacturer",
          "onSale": "On Sale",
          "ingameOnly": "In-game only",
          "stealth": "Stealth",
          "canLandOnPlanets": "Can land on planets",
          "size": "Size",
          "dockSize": "Dock Size",
          "price": "Price",
          "pledgePrice": "Pledge Price",
          "productionStatus": "Production Status",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "Price <=",
          "priceGt": "Price >=",
          "willItFit": "Will it Fit?",
          "withCargo": "With Cargo?",
          "scKeyBlank": "Without SC Key?",
          "positionsNeedCuration": "Positions Need Curation?",
          "fleetchartImageBlank": "Without Fleetchart Image?",
          "holoBlank": "Without Holo?",
          "frontViewBlank": "Without Front View Image?",
          "topViewColoredBlank": "Without Top View Colored Image?",
          "vehicleSize": "Vehicle Size",
          "dimensionsDrifted": "Dimensions differ from game files",
          "dimensionsMeasuredAtNull": "Without Measured Dimensions?",
          "hidden": "Hidden?",
          "active": "Active?"
        },
        "modelModules": {
          "name": "Name"
        },
        "manufacturers": {
          "name": "Name",
          "withModels": "With Models",
          "logoBlank": "Without Logo"
        },
        "supporterContributions": {
          "name": "Search by name",
          "recurring": "Recurring",
          "anonymous": "Anonymous",
          "startedAtGteq": "Started from",
          "startedAtLteq": "Started until",
          "user": "Linked account",
          "linked": "Account link",
          "linkedOnly": "Linked",
          "linkedVia": "Linked via",
          "unlinkedOnly": "Not linked",
          "sourceStated": "Platform stated",
          "sourceStatedOnly": "Platform stated",
          "sourceUnspecifiedOnly": "Platform unspecified",
          "source": "Source"
        },
        "adminNotifications": {
          "search": "Search"
        },
        "images": {
          "model": "Ship"
        },
        "users": {
          "search": "Search",
          "username": "Username",
          "email": "Email",
          "rsiHandle": "RSI Handle"
        },
        "fleets": {
          "name": "Name",
          "fid": "FID",
          "memberCountGteq": "Minimum members",
          "memberCountLteq": "Maximum members",
          "rsiVerified": "RSI verified",
          "publicFleet": "Public",
          "recruiting": "Recruiting",
          "createdOnGteq": "Created from",
          "createdOnLteq": "Created until",
          "member": "Member",
          "members": {
            "search": "Username or nickname",
            "role": "Role",
            "state": "Status",
            "acceptedAtGt": "Joined from",
            "acceptedAtLt": "Joined until",
            "invitedAtGt": "Invited from",
            "invitedAtLt": "Invited until",
            "requestedAtGt": "Requested from",
            "requestedAtLt": "Requested until",
            "declinedAtGt": "Declined from",
            "declinedAtLt": "Declined until",
            "inactiveSince": "Inactive since",
            "verified": "RSI organisation",
            "verifiedYes": "Verified",
            "verifiedNo": "Not verified",
            "withoutRsiHandle": "No RSI handle",
            "withoutDiscord": "No Discord linked",
            "withoutSquadron": "In no squadron"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          },
          "logistics": {
            "search": "Search items..."
          }
        },
        "manufacturer": "Manufacturer",
        "commodities": {
          "description": "Description",
          "traded": "Traded somewhere",
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "Buy Price >=",
          "buyPriceLt": "Buy Price <=",
          "sellPriceGt": "Sell Price >=",
          "sellPriceLt": "Sell Price <=",
          "storeImageBlank": "Without Store Image?"
        },
        "equipment": {
          "name": "Name",
          "equipmentType": "Equipment Type",
          "itemType": "Item Type",
          "weaponClass": "Weapon Class",
          "slot": "Slot",
          "size": "Size",
          "grade": "Grade",
          "buyPriceGt": "Buy Price >=",
          "buyPriceLt": "Buy Price <=",
          "sellPriceGt": "Sell Price >=",
          "sellPriceLt": "Sell Price <=",
          "storeImageBlank": "Without Store Image?",
          "subType": "Sub Type"
        },
        "notifications": {
          "search": "Search"
        },
        "blueprints": {
          "org": "Handed out by",
          "scKey": "Game key",
          "withKnownSource": "Has a known source",
          "withCraftable": "Output in a catalogue",
          "currentVersion": "In the current build",
          "name": "Search blueprints",
          "craftableType": "Makes",
          "source": "Source",
          "withSource": "Has a known source",
          "withoutSource": "No known source",
          "alignment": "Source alignment",
          "material": "Uses material",
          "ownedFilter": "Owned",
          "owned": "Owned",
          "notOwned": "Not owned"
        },
        "missions": {
          "location": "Location",
          "ship": "Your ship",
          "name": "Search missions",
          "org": "Offered by",
          "standing": "Standing",
          "rewarding": "Pays",
          "alignment": "Side of the law",
          "kind": "Kind",
          "system": "Star system",
          "releasedFilter": "In release",
          "released": "In release",
          "unreleased": "Not in release"
        },
        "fleetDirectory": {
          "search": "Name, FID or SID",
          "memberCountGteq": "Minimum members",
          "activity": "Activity",
          "language": "Language",
          "alignment": "Alignment",
          "commitment": "Commitment",
          "timezone": "Timezone",
          "recruiting": "Recruiting only",
          "roleplay": "Role play only"
        }
      },
      "station": {
        "docks": "Docks",
        "location": "Location",
        "type": "Type",
        "shops": "Shops",
        "locationPrefix": {
          "default": "on",
          "orbit": "in orbit around"
        }
      },
      "tradeRoutes": {
        "intro": "The best single run between two terminals for the ship you fly, the money you have and how fresh you want the prices. Prices come from UEX and refresh every hour.",
        "yourRun": "Your run",
        "ship": "Ship",
        "noShip": "Pick a ship to rank by what one run earns",
        "noShipShort": "No ship",
        "scu": "%{count} SCU",
        "budget": "Budget",
        "budgetPlaceholder": "Optional",
        "buyIn": "Buy in",
        "anySystem": "Any",
        "commodity": "Commodity",
        "allCommodities": "All commodities",
        "priceAge": "Prices no older than",
        "priceAges": {
          "day": "24 h",
          "threeDays": "3 days",
          "any": "Any"
        },
        "bestRun": "Best run",
        "buyAt": "Buy at",
        "sellAt": "Sell at",
        "pricePerScu": "%{price} aUEC / SCU",
        "distanceValue": "%{count} Gm",
        "jumpTo": "jump to %{system}",
        "pricesFrom": "Prices from %{time}",
        "otherBuyers": {
          "one": "+%{count} other place buys it",
          "other": "+%{count} other places buy it"
        },
        "profitThisRun": "Profit this run",
        "profitPerScu": "Profit per SCU",
        "aUecPerScu": "aUEC · %{value} per SCU",
        "load": "Load",
        "loadOf": "%{load} of %{cargo} SCU",
        "thisShip": "This ship",
        "unflyable": {
          "origin": "%{ship} can't land at %{terminal}",
          "destination": "%{ship} can't land at %{terminal}",
          "both": "%{ship} can't land at either end"
        },
        "loadLimits": {
          "hold": "Hold full",
          "stock": "Limited by stock",
          "demand": "Limited by demand",
          "budget": "Limited by budget"
        },
        "youSpend": "You spend",
        "pickShipForRun": "Pick a ship to see what one run earns.",
        "moreRuns": "More runs",
        "runs": "Runs",
        "rankBy": "Rank by",
        "profitPerRun": "Profit per run",
        "profitPerDistance": "Profit per Gm",
        "shortest": "Shortest",
        "buySell": "Buy → sell",
        "spend": "Spend",
        "distance": "Distance",
        "prices": "Prices",
        "profit": "Profit",
        "to": "to",
        "everyBuyer": "Every place that buys %{commodity} from %{terminal}",
        "empty": "No runs match. Try older prices or another system.",
        "loadExplained": "Load uses the crate sizes both terminals and the commodity accept, capped by stock where you buy, demand where you sell and your budget.",
        "poweredByUex": "Prices powered by UEX"
      },
      "hardpoints": {
        "prefix": "Tryout Loadouts with",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "Metrics based on the formulas of"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "Select a Ship"
      },
      "table": {
        "selected": "%{count} Selected",
        "selectRow": "Select row",
        "selectAll": "Select all rows"
      },
      "commodityPrice": {
        "item": "ShopCommodity",
        "price": "Price",
        "type": "Type",
        "shop": "Shop"
      },
      "hangarPledgeItems": {
        "openOnRsi": "Open in RSI hangar",
        "flair": "Hangar Flair",
        "upgrades": "Upgrades / CCUs",
        "equipment": "FPS Gear",
        "createdOn": "Created",
        "meltable": "Meltable",
        "withValue": "Has a melt value",
        "paints": "Paints",
        "pledge": "Pledge %{id}",
        "meltValue": "Melt value",
        "partOf": "Part of %{name}",
        "pledgeValue": "Pledge value",
        "quantity": "Quantity",
        "search": "Search by name",
        "shipComponents": "Ship Components",
        "addToInventory": "Add to inventory",
        "inventory": "Inventory",
        "inInventory": "In %{name}",
        "select": "Select",
        "andMore": {
          "one": "and %{count} more",
          "other": "and %{count} more"
        }
      },
      "buybacks": {
        "name": "Buy-back pledges",
        "search": "Search buy-back pledges",
        "kind": "Kind",
        "kinds": {
          "package": "Package",
          "ship": "Standalone ship",
          "upgrade": "Upgrade",
          "paint": "Paint",
          "addon": "Add-on",
          "other": "Other"
        },
        "upgraded": "Upgraded",
        "reclaimedOn": "Reclaimed",
        "notAvailable": "Not available",
        "price": "Price",
        "insurance": "Insurance",
        "lifetimeInsurance": "LTI",
        "noInsurance": "No insurance",
        "insuranceUnknown": "Insurance unknown",
        "insuranceMonths": {
          "one": "%{count} month",
          "other": "%{count} months"
        },
        "openOnRsi": "Buy back on RSI",
        "remove": "Remove",
        "priceRange": "Price range",
        "priceMin": "Min. price (USD)",
        "priceMax": "Max. price (USD)",
        "upgradeFrom": "Upgrade from",
        "upgradeTo": "Upgrade to",
        "gets": "Gets you the ship"
      },
      "buybackSync": {
        "extensionVersion": "Installed extension version",
        "detailsProgress": "Reading buy-back prices",
        "pages": "Pages",
        "added": "New",
        "removed": "Removed",
        "prices": "Prices read",
        "background": {
          "finished": "Buy-back sync finished",
          "incomplete": "Buy-back sync finished, some prices missing",
          "unsupported": "Buy-back sync needs a newer extension",
          "failed": "Buy-back sync failed"
        },
        "status": {
          "fetching": "Reading buy-back pages",
          "submitting": "Saving",
          "finished": "Finished",
          "unsupported": "Not supported",
          "failed": "Failed"
        },
        "stepDetails": {
          "saved": "New: %{added} · Removed: %{removed}",
          "prices": "%{done} of %{total}",
          "pricesPending": "For the pledges new since the last sync",
          "read": "Pages read: %{page} · Buy-back pledges: %{count}"
        },
        "firstSyncTitle": "The first sync takes longer",
        "updateExtensionTitle": "Update the sync extension",
        "finishedTitle": "Buy-back pledges synced",
        "runningTitle": "Syncing buy-back pledges",
        "pledges": "Buy-back pledges"
      },
      "syncExtension": {
        "warnings": "Warnings",
        "backgroundProgress": "Syncing your hangar",
        "backgroundFinished": "Hangar sync finished",
        "backgroundFailed": "Hangar sync failed",
        "backgroundCancelled": "Hangar sync cancelled",
        "status": {
          "failed": "Import Failed!",
          "cancelled": "Import Cancelled"
        },
        "processSteps": {
          "fetchHangar": "Reading your RSI hangar",
          "submitData": "Saving to Fleetyards"
        },
        "signedInAs": "Signed in to RSI as %{handle}",
        "signInToRsi": "Sign in to RSI",
        "checkIdentity": "Check RSI Session",
        "targetGroup": "Group for the ships it finds",
        "addBundledVehicles": "Add bundled snub crafts",
        "addBundledVehiclesHint": "Adds the snub craft a ship comes with. Ones already in your hangar are kept either way.",
        "syncPaints": "Sync paints",
        "syncPaintsHint": "Replaces your paints with the ones in your RSI hangar. Off leaves the stored paints as they are.",
        "syncHangarFlair": "Sync hangar flair",
        "syncHangarFlairHint": "Replaces your hangar flair with the ones in your RSI hangar. Off leaves the stored flair as it is.",
        "syncCcus": "Sync CCUs",
        "syncCcusHint": "Replaces your CCUs with those in your RSI hangar. Off keeps stored CCUs unchanged.",
        "syncEquipment": "Sync FPS gear",
        "syncEquipmentHint": "Replaces your FPS gear with the gear in your RSI hangar. Off leaves the stored gear as it is.",
        "settings": "Settings",
        "unmatchedVehiclesAction": "Ships not in your RSI hangar",
        "unmatchedVehiclesActionHint": "What to do with ships you have here that the sync cannot find in your RSI pledge list.",
        "unmatchedHangarGroup": "Group to file them into",
        "unmatchedHangarGroupHint": "The ships are left exactly as they are, just collected in this group so you can sort them out.",
        "unmatchedVehiclesActions": {
          "wishlist": "Move them to the wishlist",
          "delete": "Delete them",
          "keep": "Leave them unchanged",
          "group": "File them into a group"
        },
        "identityStatus": {
          "pending": "Checking...",
          "notFound": "not found",
          "connected": "connected"
        },
        "platforms": {
          "chrome": "Google Chrome or Chromium based Browsers",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "Pages",
          "paints": "Paints",
          "hangarFlair": "Hangar Flair",
          "paintsNotSynced": "Paints (not synced)",
          "hangarFlairNotSynced": "Hangar flair (not synced)",
          "equipment": "FPS Gear",
          "ccus": "Upgrades / CCUs",
          "ccusNotSynced": "CCUs (not synced)",
          "equipmentNotSynced": "FPS gear (not synced)",
          "extras": "Other",
          "shipComponents": "Ship components",
          "shipComponentsNotSynced": "Ship components (not synced)"
        },
        "importedItems": {
          "importedVehicles": "Added Ships",
          "foundVehicles": "Found Ships",
          "movedVehiclesToWanted": "Moved Ships to Wishlist",
          "deletedVehicles": "Deleted Ships",
          "groupedVehicles": "Ships Filed into a Group",
          "unchangedVehicles": "Ships Left Unchanged",
          "missingModels": "Ships not found",
          "importedComponents": "Added Components",
          "foundComponents": "Found Components",
          "missingComponents": "Components not found",
          "missingComponentVehicles": "No matching Ship found for Components",
          "importedUpgrades": "Added Upgrades",
          "foundUpgrades": "Found Upgrades",
          "syncedPaints": "Paints synced",
          "syncedHangarFlair": "Hangar flair synced",
          "syncedCcus": "CCUs synced",
          "syncedEquipment": "FPS gear synced",
          "missingUpgrades": "Upgrades not found",
          "missingUpgradeVehicles": "No matching Ship found for Upgrades"
        },
        "incomplete": "Some items in your RSI hangar could not be read, so ships missing from it were left as they are this time.",
        "stepDetails": {
          "read": "Pages read: %{pages} · Pledge items: %{count}",
          "saving": "Matching your pledges to your hangar…",
          "page": "Page %{page}",
          "pageOf": "Page %{page} of %{total}",
          "sending": {
            "one": "Sending %{count} item",
            "other": "Sending %{count} items"
          },
          "sent": {
            "one": "Sent %{count} item",
            "other": "Sent %{count} items"
          },
          "pageOfAbout": "Page %{page} of about %{total}"
        },
        "unmatchedCount": {
          "one": "1 item could not be matched",
          "other": "%{count} items could not be matched"
        },
        "unmatchedHeading": "Could not be matched",
        "failedStep": {
          "fetchHangar": "Reading your RSI hangar failed",
          "submitData": "Saving to Fleetyards failed"
        },
        "whatToSync": "What to sync",
        "unmatchedActionLabel": "What happens to them",
        "notSyncing": "Not syncing",
        "targetGroupHint": "Every ship the sync finds or adds is filed into this group, on top of any groups it is already in.",
        "extensionNeededTitle": "Add the sync extension",
        "finishedTitle": "Hangar synced",
        "failedTitle": "The sync did not finish",
        "savedAsYouChange": "Saved as you change them",
        "resultKinds": {
          "ships": "Ships",
          "components": "Modules",
          "upgrades": "Upgrades",
          "paints": "Paints",
          "hangarFlair": "Hangar flair",
          "equipment": "FPS gear",
          "ccus": "CCUs",
          "shipComponents": "Ship components"
        },
        "newCount": {
          "one": "+1 new",
          "other": "+%{count} new"
        },
        "resultActions": {
          "movedVehiclesToWanted": "Moved to the wishlist",
          "deletedVehicles": "Deleted",
          "groupedVehicles": "Filed into a group",
          "unchangedVehicles": "Left unchanged"
        },
        "nothingChangedTitle": "Nothing changed",
        "stepStatus": {
          "pending": "Not started",
          "active": "In progress",
          "done": "Done",
          "failed": "Failed",
          "warning": "Done with warnings"
        },
        "lastSync": {
          "of": "of %{count}",
          "ofLong": "%{count} in the last sync",
          "more": "%{count} more than the last sync",
          "fewer": "%{count} fewer than the last sync",
          "same": "As many as the last sync",
          "reading": "%{count} of about %{total} items"
        },
        "viewImport": "View this sync's import",
        "lastSynced": "Last synced",
        "syncShipComponents": "Sync ship components",
        "syncShipComponentsHint": "Replaces your ship components (coolers, power plants, weapons, …) with those in your RSI hangar. Off keeps stored ship components unchanged."
      },
      "cargoGridViewer": {
        "capacity": "Capacity",
        "maxContainerSize": "Max. Container",
        "packed": "Packed",
        "totalCargo": "Total Cargo",
        "didNotFit": "Did not fit",
        "enoughShips": "Four ships fill the grid.",
        "addShip": "Add Ship",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "travelTimes": {
        "quantumDrive": "Quantum Drive",
        "fuelUsage": "Fuel Usage",
        "travelTime": "Travel Time",
        "poweredBy": "powered by",
        "rank": "#",
        "size": "Size",
        "grade": "Grade",
        "sizeValue": "S%{size}",
        "intro": "How long each quantum drive takes for your jump — and how much quantum fuel it burns getting there.",
        "jumpDistance": "Jump distance",
        "distanceHint": "1 Mkm is a million kilometres. Crossing Stanton is about 40.",
        "filters": "Filters",
        "resetFilters": "Reset",
        "barLegend": "Bar shows time against the slowest drive",
        "count": "%{count} drives",
        "countFiltered": "%{count} of %{total} drives",
        "noMatch": "No drive matches these filters.",
        "presets": {
          "moon": "Moon hop",
          "short": "Short jump",
          "system": "Across Stanton",
          "far": "Long haul"
        }
      },
      "admin": {
        "importLoaders": {
          "ship_matrix_all": {
            "name": "Everything",
            "description": "Ships, modules, paints, loaners and ship prices, all at once."
          },
          "ship_matrix": {
            "name": "Ships",
            "description": "Every ship with its specs and store data, from the RSI ship matrix."
          },
          "modules": {
            "name": "Modules",
            "description": "Ship modules from the RSI pledge store."
          },
          "paints": {
            "name": "Paints",
            "description": "Paints from the RSI pledge store."
          },
          "loaners": {
            "name": "Loaners",
            "description": "Which loaners come with each ship, from RSI."
          },
          "uex_vehicle_prices": {
            "name": "Ship prices",
            "description": "Where ships are bought and rented in game, from UEX."
          },
          "sc_data": {
            "name": "Game data · %{environment}",
            "description": "Every catalogue from the parsed game files: components, equipment, commodities, blueprints, missions and places."
          },
          "sc_data_models": {
            "name": "Ships from the game files",
            "description": "Only the ships, from the default build."
          },
          "uex_commodity_prices": {
            "name": "Commodity prices",
            "description": "Terminal prices and stock, from UEX."
          },
          "uex_component_prices": {
            "name": "Component prices",
            "description": "Where components are sold, from UEX."
          },
          "uex_equipment_prices": {
            "name": "Equipment prices",
            "description": "Where equipment is sold, from UEX."
          },
          "uex_trade_routes": {
            "name": "Terminals and trade routes",
            "description": "UEX's terminals and the trade routes between them."
          },
          "environments": {
            "live": "Live",
            "ptu": "PTU"
          }
        },
        "locations": {
          "parent": "Parent",
          "system": "System",
          "scKey": "Game key",
          "scRefs": "Game refs",
          "slug": "Slug",
          "gameType": "Game type",
          "build": "Build",
          "children": "Places inside",
          "missions": "Missions linked",
          "missionTemplates": "Mission templates",
          "shownWithParentOnly": "Only shown with its parent",
          "yes": "Yes",
          "no": "No",
          "unavailable": "unavailable",
          "appearance": "Appearance",
          "image": "Image",
          "color": "Color",
          "appearanceHint": "The color fills the planet or moon’s circle, shaded as a lit sphere. Left empty, it is taken from the picture when one is uploaded.",
          "headerImageHint": "The picture is shown as a header image on the place’s page.",
          "shops": "Shops",
          "shopImageHint": "The picture is shown as the header image on the shop’s page.",
          "sunHint": "The color tints the star’s glow."
        },
        "blueprints": {
          "status": {
            "sourceKnown": "Source known",
            "outputResolved": "Output in a catalogue"
          },
          "columns": {
            "source": "Source",
            "output": "Output",
            "build": "Build",
            "created": "Created at",
            "slot": "Slot",
            "material": "Material",
            "type": "Type",
            "quantity": "Quantity",
            "minQuality": "Min quality",
            "stat": "Stat",
            "change": "Change",
            "base": "Base",
            "ramp": "Ramp",
            "kind": "Kind",
            "org": "Org",
            "mission": "Mission",
            "standing": "Standing",
            "pool": "Pool"
          },
          "makes": "Makes",
          "noOutput": "Not in a catalogue",
          "slug": "Slug",
          "scKey": "Game key",
          "scRef": "Game ref",
          "build": "Build",
          "state": "State",
          "states": {
            "current": "Current",
            "retired": "Retired"
          },
          "createdAt": "Created at",
          "updatedAt": "Updated at"
        },
        "missions": {
          "unnamed": "Never named by the game",
          "slug": "Slug",
          "scKey": "Game key",
          "scRef": "Game ref",
          "generator": "Generator",
          "debugName": "Debug name",
          "build": "Build",
          "difficultyAxes": "Difficulty (skill / load / risk / knowledge)",
          "state": "State",
          "states": {
            "retired": "Retired",
            "released": "In release",
            "unreleased": "Not in release"
          },
          "columns": {
            "released": "In release",
            "generator": "Generator",
            "build": "Build",
            "rewardKind": "Kind",
            "amount": "Amount",
            "rewardDetail": "Detail"
          },
          "filters": {
            "debugName": "Debug name",
            "named": "Named",
            "unnamed": "Never named",
            "namedFilter": "Naming",
            "currentBuild": "Current build only",
            "anyBuild": "Any build",
            "build": "Build"
          }
        },
        "dashboard": {
          "quickStats": {
            "onlineUsers": "Online Users",
            "visitsToday": "Visits Today",
            "signupsThisWeek": "Signups This Week"
          },
          "attention": {
            "unlistedModels": "Ships awaiting a decision",
            "failedImports": "Imports failed today",
            "stuckImports": "Imports stuck running",
            "deadJobs": "Jobs given up on",
            "retryJobs": "Jobs retrying",
            "rsiRequestLogs": "Unresolved RSI failures",
            "notifications": "Notifications needing action"
          },
          "catalogueUnknown": "No build recorded",
          "systemAuthor": "System",
          "moreFields": "+%{count} more"
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "kofi": "Ko-fi",
            "buymeacoffee": "Buy me a coffee",
            "paypal": "PayPal",
            "other": "Other"
          },
          "linkedVia": {
            "patreon_account": "Patreon account",
            "claim_key": "Supporter token",
            "payer_email": "Payer email",
            "manual": "Set by an admin"
          }
        },
        "announcements": {
          "columns": {
            "title": "Title",
            "status": "Status",
            "deliveries": "Channels",
            "recipients": "Recipients",
            "publishedAt": "Sent"
          },
          "statuses": {
            "draft": "Draft",
            "scheduled": "Scheduled",
            "publishing": "Sending",
            "published": "Sent",
            "failed": "Failed"
          },
          "channels": {
            "in_app": "In-app",
            "discord": "Discord",
            "bluesky": "Bluesky"
          },
          "deliveryStatuses": {
            "pending": "Pending",
            "succeeded": "Sent",
            "skipped": "Skipped",
            "failed": "Failed"
          },
          "lastTested": "Last tested %{time}",
          "noChannel": "Pick at least one channel.",
          "notifyUsersInfo": "E-mail only if they opted in.",
          "discordPartsInfo": "Empty: split automatically.",
          "socialPartsInfo": "Empty: one post, trimmed. Two or more: a thread.",
          "recipientsCount": "%{count} recipients",
          "partPosition": "%{position} of %{total}",
          "deliverySummary": "%{sent}/%{total} sent",
          "deliveryFailedCount": "%{count} failed",
          "deliveryPendingCount": "%{count} pending",
          "deliverySkippedCount": "%{count} skipped",
          "attempts": "%{count} attempts",
          "content": "Content",
          "manualPostsInfo": "The text Bluesky gets, to post by hand on X or elsewhere.",
          "engagement": {
            "likes": "Likes",
            "reposts": "Reposts",
            "replies": "Replies",
            "quotes": "Quotes",
            "noReactions": "No reactions yet.",
            "fetchedAt": "Updated %{time}",
            "notFetched": "Counts arrive within the hour.",
            "untracked": "Posted before reactions were tracked."
          }
        },
        "resourceAccess": {
          "title": "Resource Access",
          "groups": {
            "ship_data": "Ship Data",
            "community": "Community",
            "system": "System"
          },
          "privileges": {
            "locations": "Locations",
            "blueprints": "Blueprints",
            "models": "Models",
            "model_modules": "Model Modules",
            "components": "Components",
            "manufacturers": "Manufacturers",
            "vehicles": "Vehicles",
            "images": "Images",
            "fleets": "Fleets",
            "users": "Users",
            "supporters": "Supporters",
            "admins": "Admins",
            "announcements": "Announcements",
            "game_events": "Game events",
            "homepage": "Homepage",
            "oauth_applications": "OAuth Applications",
            "maintenance": "Maintenance",
            "imports": "Imports",
            "features": "Features",
            "workers": "Workers",
            "pghero": "PgHero",
            "rsi-api-status": "RSI API Status",
            "stats": "Stats"
          }
        },
        "versions": {
          "blank": "empty",
          "revertQuestion": "Revert?",
          "sources": {
            "custom": "Admin",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "Game Files",
            "sc_loader": "Game Files",
            "uex_price_sync": "UEX Price Sync",
            "unknown": "Unknown"
          }
        },
        "models": {
          "unlisted": "Unlisted"
        }
      },
      "hangarTable": {
        "extraColumns": "Columns",
        "columns": {
          "storeImage": "Image",
          "storeImageWide": "Wide Image",
          "angledView": "3D Image",
          "angledViewWide": "Wide 3D Image",
          "modelManufacturerName": "Manufacturer",
          "modelLength": "Length",
          "modelBeam": "Beam",
          "modelHeight": "Height",
          "modelMass": "Mass",
          "modelCargo": "Cargo",
          "modelCrew": "Crew",
          "maxWeaponSize": "Weapons",
          "alpha": "Alpha",
          "burstDps": "Burst DPS",
          "sustainedDpsMax": "Sustained DPS",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Max Speed",
          "modelGroundMaxSpeed": "Ground Speed",
          "modelFocus": "Focus",
          "modelProductionStatus": "Production Status",
          "modelPrice": "Price",
          "modelPledgePrice": "Pledge Price"
        }
      },
      "fleetTable": {
        "extraColumns": "Columns",
        "columns": {
          "storeImage": "Image",
          "storeImageWide": "Wide Image",
          "angledView": "3D Image",
          "angledViewWide": "Wide 3D Image",
          "modelManufacturerName": "Manufacturer",
          "modelLength": "Length",
          "modelBeam": "Beam",
          "modelHeight": "Height",
          "modelMass": "Mass",
          "modelCargo": "Cargo",
          "modelCrew": "Crew",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Max Speed",
          "modelGroundMaxSpeed": "Ground Speed",
          "modelProductionStatus": "Production Status",
          "modelPrice": "Price",
          "modelPledgePrice": "Pledge Price",
          "owner": "Owner",
          "vehiclesCount": "Count"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "entriesCount": "entries",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "componentCategory": "Component Type",
        "commodityType": "Commodity Type",
        "crafted": {
          "request": "Ask for a crafted part",
          "page": "Crafted from %{recipe} at grades %{grades}. Highlighted figures differ from the catalogue's.",
          "showStock": "Show stock values",
          "edit": "Record how it was crafted",
          "summary": "Crafted %{grades}",
          "lot": "Crafted",
          "grade": "Q %{quality}",
          "slotGrade": "Slot %{position}: %{quality}"
        },
        "itemPicker": {
          "field": "Item",
          "placeholder": "Choose an item",
          "custom": "Add “%{name}” as a custom item",
          "search": "Search by name",
          "chooseCategory": "Choose a category to browse its items.",
          "results": {
            "one": "%{count} Item",
            "other": "%{count} Items"
          },
          "noResults": "No items match these filters.",
          "clear": "Remove the catalogue item",
          "capacity": "Capacity"
        },
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "description": "Description",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "general": "General"
        },
        "priorities": {
          "standard": "Standard",
          "critical": "Critical"
        },
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityShort": "Q %{quality}",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "noDepositTargets": "There is no inventory you can deposit into.",
        "personalInventory": "Personal",
        "personalInventoryNameLocked": "Your personal inventory keeps its name.",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only",
          "squadron_only": "Squadron only"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other",
          "armor": "Armor",
          "clothing": "Clothing",
          "tool": "Tool",
          "container": "Container"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "lots": "Lots",
        "linkedItem": "Linked item",
        "catalogueIdentity": "Name and category come from the linked catalogue item.",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "openInCatalogue": "Open in the catalogue",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "over cargo capacity",
        "cargoGrid": "Cargo Grid",
        "shipInventory": "Ship Inventory",
        "remaining": "Remaining",
        "unmeasured": "%{count} not measured yet",
        "transferTarget": "Recipient",
        "transferNote": "Note",
        "noStock": "Nothing to move",
        "overStock": "More than this position holds",
        "incoming": "Incoming",
        "outgoing": "Outgoing",
        "transferStates": {
          "pending": "Waiting",
          "completed": "Delivered",
          "declined": "Declined",
          "cancelled": "Withdrawn",
          "expired": "Expired"
        },
        "acceptInto": "Accept into",
        "reportReason": "Reason",
        "reportReasons": {
          "spam": "Spam",
          "harassment": "Harassment",
          "scam": "Scam",
          "other": "Something else"
        },
        "transferToFleet": "%{fleet} (fleet)",
        "sender": "From",
        "recipient": "To",
        "contents": "Contents",
        "state": "Status",
        "sentAt": "Sent",
        "transferKinds": {
          "inventory": "My inventories",
          "fleet": "A fleet",
          "user": "A person",
          "mine": "My inventories",
          "fleetInventories": "This fleet",
          "contract": "A contract I work on"
        },
        "transferTargetKind": "Send to",
        "contractDeliveryTarget": "%{contract} (%{fleet}): %{destination}",
        "transferFromFleet": "From fleet",
        "noTransferTargets": "Nothing to send to here",
        "recordedAt": "Recorded",
        "origin": "From / To",
        "inTransitAmount": "%{amount} in transit",
        "inTransitHint": "Sent on a transfer nobody has answered yet. It is already out of the totals.",
        "transferFromFriends": "My friends",
        "towardsContract": "Towards a contract",
        "noContract": "No contract",
        "forContract": "for"
      },
      "hangarInventories": "Inventories",
      "hangarBlueprints": {
        "owned": "Owned",
        "wanted": "Wanted",
        "missions": "Missions"
      },
      "adminNotifications": {
        "inbox": "Inbox",
        "archive": "Archive",
        "unreadOnly": "Unread only",
        "status": "Status",
        "severity": "Severity",
        "type": "Type",
        "selectPrompt": "Select a notification to read it",
        "noBody": "This notification carries no further details.",
        "lastSeen": "Last seen",
        "expires": "Expires",
        "severities": {
          "info": "Info",
          "warning": "Warning",
          "error": "Error"
        },
        "types": {
          "paints_import": "Paints Import",
          "modules_import": "Modules Import",
          "loaner_sync": "Loaner Sync",
          "uex_prices_import": "UEX Price Sync",
          "uex_commodity_prices_import": "UEX Commodity Sync",
          "uex_component_prices_import": "UEX Component Sync",
          "uex_equipment_prices_import": "UEX Equipment Sync",
          "uex_trade_routes_sync": "UEX Trade Route Sync",
          "new_supporter": "New Supporter",
          "rsi_api_blocked": "RSI API Blocked",
          "rsi_api_unblocked": "RSI API Restored",
          "rsi_markup_changed": "RSI Page Changed",
          "weekly_stats": "Weekly Report",
          "ship_matrix_import": "Ship Matrix Import",
          "sc_data_import": "sc_data Import",
          "sc_data_unlisted_models": "Unlisted Ships",
          "unplaced_foci": "Unplaced Focus Wording",
          "import_run": "Import",
          "oauth_application_review": "OAuth Application Review",
          "inventory_transfer_reports": "Reported Inventory Transfers"
        }
      },
      "optional": "optional",
      "notificationActions": {
        "open": "Open",
        "openHangar": "Open hangar",
        "openModel": "Show ship",
        "openInvite": "View invite",
        "reviewRequest": "Review request",
        "openMembers": "Show members",
        "openFleet": "Open fleet",
        "openInventory": "Open inventory",
        "openEvent": "Open event",
        "openRoster": "Show sign-ups",
        "addToCalendar": "Add to calendar",
        "openStore": "Pledge store",
        "accept": "Accept",
        "decline": "Decline",
        "signUp": "Sign up",
        "withdraw": "Withdraw",
        "syncAgain": "Sync again",
        "markAsBought": "Mark as bought",
        "unavailable": "This is no longer available.",
        "openTransfers": "Open transfers",
        "openFriends": "Open friends",
        "openAllies": "Open allies",
        "openTour": "Open tour",
        "openSquadron": "Open squadron",
        "openContract": "Open contract",
        "openPayouts": "Open payouts"
      },
      "notificationTypes": {
        "channels": {
          "app": "App",
          "mail": "Mail",
          "push": "Push",
          "discord": "Discord"
        },
        "groups": {
          "account": "Account & hangar",
          "announcements": "Announcements",
          "fleetMembership": "Fleet membership",
          "fleetEvents": "Fleet events",
          "logistics": "Logistics",
          "relationships": "Friends & allies",
          "tours": "Tours",
          "fleetContracts": "Fleet contracts"
        },
        "announcement": "Announcement",
        "hangar_sync_finished": "Hangar sync finished",
        "hangar_sync_failed": "Hangar sync failed",
        "model_on_sale": "Model on sale",
        "new_model": "New model released",
        "fleet_invite": "Fleet invite received",
        "fleet_member_requested": "Membership requested",
        "fleet_member_accepted": "Membership accepted",
        "fleet_request_accepted": "Join request accepted",
        "fleet_joined_by_discord_role": "Joined through Discord role",
        "fleet_inventory_item_added": "Fleet inventory item added",
        "fleet_event_published": "Event published",
        "fleet_event_locked": "Event sign-ups locked",
        "fleet_event_starting_soon": "Event starting soon",
        "fleet_event_started": "Event started",
        "fleet_event_completed": "Event completed",
        "fleet_event_cancelled": "Event cancelled",
        "fleet_event_signup_added": "New signup",
        "fleet_event_signup_withdrawn": "Signup withdrawn",
        "fleet_event_signup_confirmed": "Signup confirmed",
        "fleet_event_signup_assigned": "Assigned to a slot",
        "fleet_event_signup_kicked": "Removed from a slot",
        "allInGroup": "Everything in this group",
        "inventory_transfer_received": "Transfer received",
        "inventory_transfer_resolved": "Transfer answered",
        "friend_request_received": "Friend request received",
        "friend_request_accepted": "Friend request accepted",
        "fleet_ally_request_received": "Ally request received",
        "fleet_ally_request_accepted": "Ally request accepted",
        "tour_join_request_received": "Join request received",
        "tour_join_request_accepted": "Join request accepted",
        "fleet_squadron_request_received": "Squadron join request",
        "fleet_squadron_request_accepted": "Squadron request accepted",
        "fleet_contract_published": "Contract posted",
        "fleet_announcement_posted": "Announcement posted",
        "fleet_contract_claimed": "Contract claimed",
        "fleet_contract_crew_requested": "Crew wants to join a contract",
        "fleet_contract_crew_answered": "Contract crew request answered",
        "fleet_subscription_started": "Fleet features unlocked",
        "fleet_subscription_ended": "Fleet features lost",
        "supporter_coverage_ending": "Supporter perks ending soon",
        "supporter_coverage_ended": "Supporter perks ended",
        "fleet_fid_claim_opened": "Fleet ID claimed",
        "fleet_fid_claim_completed": "Fleet ID moved",
        "fleet_fid_claim_cancelled": "Fleet ID claim ended",
        "fleet_rsi_verification_lost": "Fleet verification lost",
        "rsi_handle_verification_lost": "RSI handle verification lost",
        "fleet_contract_fulfilled": "Contract fulfilled",
        "fleet_contract_settled": "Contract paid out",
        "payout_ledger_settled": "Payouts settled",
        "payout_entry_pending_review": "Expense waiting for review",
        "payout_entry_declined": "Expense declined",
        "fleet_verification_requested": "Verification requested by your fleet"
      },
      "fleets": {
        "missions": {
          "untitled": "Untitled mission",
          "title": "Title",
          "description": "Description",
          "team": "Team",
          "teams": "Teams",
          "ship": "Ship",
          "ships": "Ships",
          "slot": "Slot",
          "slots": "Slots",
          "noMissions": "No missions yet.",
          "noTeams": "No teams added yet.",
          "noShips": "No ships added yet.",
          "noSlots": "No slots added yet.",
          "archivedTab": "Archived",
          "activeTab": "Active",
          "archived": "Archived",
          "modelSpecific": "Specific Ship",
          "modelList": "Any of these",
          "modelListHint": "The spot takes any one of the ships you pick.",
          "allowedShips": "Ships that fit",
          "anyOf": "Any of",
          "filterRange": "Filter Range",
          "classification": "Classification",
          "focus": "Focus",
          "minSize": "Min Size",
          "maxSize": "Max Size",
          "minCrew": "Min Crew",
          "minCrewOverride": "Override",
          "minCrewOverrideLabel": "Min Crew Override",
          "minCrewOverrideHint": "Leave empty to use the ship's crew.",
          "minCargo": "Min Cargo (SCU)",
          "createdBy": "Created by",
          "seats": "Seats",
          "category": "Category",
          "coverImage": "Cover Image",
          "scenario": "Scenario",
          "categories": {
            "other": "Other",
            "ship_combat": "Ship Combat",
            "ground_combat": "Ground Combat",
            "combined_combat": "Combined Combat",
            "mining": "Mining",
            "salvage": "Salvage",
            "cargo_hauling": "Cargo Hauling",
            "exploration": "Exploration"
          }
        },
        "events": {
          "untitled": "Untitled event",
          "title": "Title",
          "description": "Description",
          "briefing": "Briefing",
          "startsAt": "Starts at",
          "endsAt": "Ends at",
          "timezone": "Timezone",
          "location": "Event location",
          "meetupLocation": "Meetup location",
          "visibility": "Visibility",
          "maxAttendees": "Max attendees",
          "autoLockEnabled": "Auto-lock signups",
          "autoLockMinutesBefore": "Lock minutes before start",
          "recurring": "Repeats",
          "recurringHint": "Generate this event automatically on a recurring schedule. Members sign up per occurrence.",
          "recurringSummary": "Repeats %{interval}",
          "recurringUntil": "Repeats %{interval} until %{date}",
          "recurringForCount": "Repeats %{interval} (%{count} occurrences)",
          "viewSeries": "View series",
          "recurrenceInterval": "Repeat every",
          "recurrenceEnd": "Ends",
          "recurrenceEndNever": "Never",
          "recurrenceEndOn": "On date",
          "recurrenceEndAfter": "After",
          "recurrenceEndOccurrences": "occurrences",
          "recurrenceUnit": {
            "daily": "days",
            "weekly": "weeks",
            "monthly": "months"
          },
          "recurrenceWeekdays": "On",
          "recurrenceWeekdaysHint": "The day the event starts on is always included.",
          "recurrence": {
            "daily": "daily",
            "weekly": "weekly",
            "monthly": "monthly",
            "everyN": {
              "daily": "every %{count} days",
              "weekly": "every %{count} weeks",
              "monthly": "every %{count} months"
            },
            "onDays": "%{interval} on %{days}"
          },
          "occurrencesSection": "Upcoming occurrences",
          "skipOccurrence": "Skip this occurrence",
          "overrideOccurrence": "Override occurrence on %{date}",
          "overrideOccurrenceShort": "Edit this one",
          "overrideOccurrenceHint": "Override fields for this single occurrence. Leave blank to inherit from the recurring event.",
          "endSeriesHere": "Stop here and going forward",
          "splitSeriesHere": "Edit this and following",
          "splitSeriesConfirm": "Continue the series from this date as a new event? Signups for this and later dates move with it, and the new event opens for editing.",
          "excludedBadge": "Skipped",
          "noUpcomingOccurrences": "No upcoming occurrences in the next 12 weeks.",
          "endSeriesConfirm": "Stop the recurrence after this date? Future occurrences won't be generated.",
          "skipOccurrenceSuccess": "Occurrence skipped.",
          "unskipOccurrence": "Restore this occurrence",
          "unskipOccurrenceSuccess": "Occurrence restored.",
          "endSeriesSuccess": "Series ended from this date forward.",
          "cancelledReason": "Cancellation reason",
          "createdBy": "Created by",
          "signups": "Signups",
          "signupsCount": "%{count} signups",
          "youAreHere": "You're here",
          "attendance": "Attendance",
          "signupsLockedHint": "Sign-ups are locked for this event.",
          "alreadySignedUpHint": "You're already signed up to a different slot. Withdraw first to switch.",
          "slotTakenHint": "This slot is already taken.",
          "currentSlot": "Current slot",
          "currentSlotHint": "This is the slot the signup is currently in.",
          "takenBy": "Taken by %{username}",
          "slotPickerHint": "Pick a slot for this signup. Slots that are already taken or unavailable are disabled.",
          "signupCtaHint": "Sign up to the event — you can pick a specific slot now or let an admin assign you later.",
          "noSlotYet": "No slot yet",
          "signupApproval": "Signup approval",
          "signupStatuses": {
            "confirmed": "Confirmed",
            "tentative": "Tentative",
            "interested": "Interested",
            "pending": "Pending approval",
            "withdrawn": "Withdrawn"
          },
          "signupApprovals": {
            "direct": "Direct",
            "confirmation_required": "Needs confirmation"
          },
          "unassignedSignupsHint": "These members signed up to the event but don't have a slot yet. Assign them below or remove the signup.",
          "taken": "Taken",
          "grantedRoles": "Granted roles",
          "noEventAdminsYet": "No additional admins or moderators yet.",
          "creator": "Event creator",
          "eventTeamHint": "Grant other members admin or moderator rights for this event. Admins can edit it, moderators can manage signups.",
          "eventRole": "Role",
          "eventRoles": {
            "admin": "Admin",
            "moderator": "Moderator"
          },
          "memberPicker": "Member",
          "spawnedEvents": "Spawned events",
          "fromMission": "From mission",
          "pickTemplate": "Pick a template",
          "pickTemplateHint": "Optionally start from a mission — its details, teams, ships and slots are copied onto the event, which stays linked to it.",
          "noTemplate": "No template",
          "noTemplateHint": "Build the event from scratch.",
          "pickTemplateLoadFailed": "The fleet's missions could not be loaded.",
          "pickTemplatePageFailed": "The next missions could not be loaded.",
          "pickTemplateSearch": "Search missions",
          "pickTemplateNonePublished": "None of the fleet's active missions is published yet.",
          "pickTemplateNoneActive": "The fleet has no active missions.",
          "pickTemplateNoMatch": "No published mission matches the search.",
          "changeTemplate": "Change template",
          "clearTemplate": "Clear template",
          "myVehicle": "My vehicle",
          "selectVehicle": "Select a vehicle (optional)",
          "vehicleMismatchHint": "The selected vehicle doesn't match this slot's requirements.",
          "noFittingInHangar": "Nothing in your hangar fits this slot. You can still sign up by leaving the vehicle empty.",
          "vehicleFitsHint": "Bringing a vehicle that fits this ship.",
          "notes": "Notes",
          "upcomingTab": "Upcoming",
          "pastTab": "Past",
          "archivedTab": "Archived",
          "listTab": "List",
          "calendarTab": "Calendar",
          "subscribeHint": "Copies the calendar feed URL to your clipboard so you can paste it into your calendar app.",
          "visibilities": {
            "members": "Members",
            "officers": "Officers",
            "fleet": "Public",
            "squadron": "Squadron only"
          },
          "statuses": {
            "draft": "Draft",
            "open": "Open for sign-ups",
            "locked": "Sign-ups locked",
            "active": "Live",
            "completed": "Completed",
            "cancelled": "Cancelled",
            "past": "Past"
          },
          "tabs": {
            "basic": "Basic info",
            "description": "Description & cover",
            "teams": "Teams & ships",
            "overview": "Overview",
            "settings": "Settings"
          },
          "calendar": {
            "month": "Month",
            "timesIn": "Times in %{zone}",
            "week": "Week",
            "weekTitle": "Week of %{date}"
          },
          "repeats": "Repeats"
        },
        "contracts": {
          "tabs": {
            "details": "Details",
            "delivery": "Delivery",
            "crew": "Crew & reward",
            "goods": "Goods"
          },
          "title": "Title",
          "description": "Description",
          "reward": "Reward",
          "rewardType": {
            "label": "How it pays",
            "fixed": "A fixed amount",
            "per_unit": "Per SCU or unit delivered",
            "none": "No reward"
          },
          "rewardPerUnit": "Reward per SCU or unit",
          "rewardPerUnitHint": "Each line of goods sets its own rate. Contractors earn it for every SCU or unit they deliver, up to what the line asks for.",
          "rewardUpTo": "Reward, up to",
          "rateMissing": "No rate yet",
          "rewardRate": {
            "scu": "%{currency} / SCU",
            "units": "%{currency} / unit",
            "mixed": "%{currency} / SCU or unit"
          },
          "noReward": "No reward",
          "maxReward": "Up to %{amount}",
          "deadline": "Deadline",
          "crewLimit": "Crew limit",
          "visibility": "Visibility",
          "visibilities": {
            "members_only": "All members",
            "squadron_only": "Squadron only"
          },
          "reimburseExpenses": "Reimburse expenses",
          "from": "Collect from",
          "to": "Deliver to",
          "toHint": "Deliveries into one of your own inventories are sent to you, and you accept them yourself.",
          "toAuthorHint": "Deliveries go to %{username}, who accepts them.",
          "myHangarInventory": "%{name} (my hangar)",
          "authorHangarInventory": "%{name} (hangar of %{username})",
          "destinationGroups": {
            "personal": "Personal",
            "fleet": "Fleet"
          },
          "scopeFilter": "Contracts",
          "scopes": {
            "all": "All contracts",
            "personal": "Personal",
            "fleet": "Fleet"
          },
          "personalBadge": "Personal",
          "personalContractsEnabled": "Personal contracts",
          "personalContractsEnabledHint": "Members can post contracts that deliver into their own inventory and that they pay for themselves.",
          "destinationRemoved": "No longer available",
          "lead": "Lead",
          "pendingCrew": "Waiting to join",
          "minQuality": "min. quality %{value}",
          "craftedAny": "Crafted, any quality",
          "craftedAtLeast": "Crafted, at least %{grades}",
          "craftedExact": "Crafted, exactly %{grades}",
          "pickedUp": "%{quantity} picked up",
          "itemCategory": "Category",
          "itemUnit": "Unit",
          "itemQuantity": "Quantity",
          "kind": {
            "label": "Type",
            "transport": "Transport",
            "procurement": "Procurement",
            "crafting": "Crafting"
          },
          "state": {
            "draft": "Draft",
            "open": "Open",
            "in_progress": "In progress",
            "fulfilled": "Fulfilled",
            "cancelled": "Cancelled",
            "expired": "Expired",
            "settled": "Settled"
          },
          "itemTypes": {
            "Commodity": "Commodity",
            "Component": "Component",
            "Equipment": "Equipment"
          },
          "qualityMatch": "Match",
          "exactQuality": "exactly %{value}",
          "qualityMatches": {
            "at_least": "At least",
            "exact": "Exactly"
          },
          "itemQuality": "Quality",
          "titleHint": "Optional — a contract without one is named after the goods it asks for",
          "postedBy": "Posted by",
          "claimedBy": "claimed by",
          "delivered": "Delivered",
          "deliveredOf": "%{delivered} / %{requested} %{unit}",
          "views": {
            "open": "Open",
            "closed": "Closed",
            "mine": "Mine",
            "completed": "Completed"
          }
        }
      },
      "commodity": {
        "name": "Name",
        "buyPrice": "Buy",
        "sellPrice": "Sell",
        "retired": "No longer in the current build",
        "containerSizes": "Container sizes (SCU)",
        "pieceVolume": "Volume per piece (SCU)",
        "consumable": "Consumable",
        "refinesInto": "Refines into",
        "refinedFrom": "Refined from",
        "availability": {
          "retired": "Prices are tracked for the build the catalogue is on, and this commodity is not in it.",
          "craftedOnly": "No terminal trades this — it is a crafting material.",
          "none": "No terminal we know of buys or sells this."
        },
        "chart": {
          "buyHighest": "Buy, highest",
          "buyAverage": "Buy, average",
          "buyLowest": "Buy, lowest",
          "sellHighest": "Sell, highest",
          "sellAverage": "Sell, average",
          "sellLowest": "Sell, lowest"
        },
        "types": {
          "agricultural_supply": "Agricultural Supplies",
          "alloy": "Alloys",
          "consumer_goods": "Consumer Goods",
          "drink": "Drinks",
          "food": "Food",
          "gas": "Gases",
          "hpmc": "HPMC",
          "manmade": "Manmade",
          "medical_supply": "Medical Supplies",
          "metal": "Metals",
          "military_supply": "Military Supplies",
          "mineral": "Minerals",
          "natural": "Natural",
          "nonmetals": "Nonmetals",
          "plasma_fuel": "Plasma Fuel",
          "processed_goods": "Processed Goods",
          "quantum_fuel": "Quantum Fuel",
          "rmc": "RMC",
          "scrap": "Scrap",
          "vice": "Vice",
          "waste": "Waste"
        },
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "slot": "Slot",
        "size": "Size",
        "grade": "Grade",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image",
        "name": "Name",
        "manufacturer": "Manufacturer",
        "retired": "No longer in the current build",
        "standard": "Standard",
        "ports": {
          "Magazine": "Magazine",
          "IronSight": "Optics",
          "Barrel": "Barrel",
          "BottomAttachment": "Underbarrel",
          "Utility": "Modules",
          "Missile": "Missiles",
          "other": "Other"
        },
        "noMetrics": "No figures are recorded for this item.",
        "gear": {
          "condition": "%{mode} from %{percent} heat",
          "damageDropValue": "from %{distance}, −%{perMeter} per m, down to %{minimum}",
          "sections": {
            "ammo": "Ammunition",
            "secondaryAmmo": "Secondary Ammunition",
            "magazine": "Magazine",
            "heat": "Heat",
            "melee": "Melee",
            "explosion": "Explosion",
            "modifier": "Effect on the Weapon",
            "mining": "Mining",
            "consumable": "Dose"
          },
          "fireModes": {
            "rapid": "Automatic",
            "single": "Single",
            "burst": "Burst",
            "charged": "Charged",
            "beam": "Beam"
          },
          "toolActions": {
            "heal": "Healing",
            "tractor": "Tractor Beam",
            "salvage": "Salvage",
            "repair": "Repair",
            "mining": "Mining",
            "charge": "Charge",
            "drain": "Drain",
            "extinguish": "Extinguish"
          },
          "targets": {
            "target": "Patient",
            "self": "Self"
          },
          "triggers": {
            "laser": "Laser Tripwire",
            "proximity": "Proximity"
          },
          "damageTypes": {
            "physical": "Physical",
            "energy": "Energy",
            "distortion": "Distortion",
            "thermal": "Thermal",
            "biochemical": "Biochemical",
            "stun": "Stun"
          },
          "meleeAttacks": {
            "blade_slash": "Slash",
            "blade_stab": "Stab"
          },
          "bodyStats": {
            "hunger": "Hunger",
            "thirst": "Thirst",
            "blood_drug_level": "Blood Drug Level",
            "stun": "Stun"
          },
          "buffs": {
            "dehydrating": "Dehydrating",
            "hydrating": "Hydrating",
            "hypertrophic": "Hypertrophic",
            "atrophic": "Atrophic",
            "hyper_metabolic": "Hyper-metabolic",
            "hypo_metabolic": "Hypo-metabolic",
            "cognitive_boost": "Cognitive Boost",
            "cognitive_impair": "Cognitive Impairment",
            "energizing": "Energizing",
            "radiation_antidote": "Radiation Treatment",
            "overdose_revival": "Overdose Revival",
            "overdose_revival_bdl_decay": "Faster Drug Clearance",
            "drug_duration_multiplier": "Changed Drug Duration",
            "slam": "SLAM",
            "stun_recovery_mask": "Suppresses Stun",
            "impact_resistance_knockdown_mask": "Suppresses Knockdown",
            "impact_resistance_stagger_mask": "Suppresses Stagger",
            "impact_resistance_twitch_mask": "Suppresses Twitching",
            "impact_resistance_flinch_mask": "Suppresses Flinching",
            "move_speed_mask": "Suppresses Slowed Movement",
            "weapon_sway_mask": "Suppresses Weapon Sway",
            "ads_enter_mask": "Suppresses Slow Aiming",
            "stamina_regen_mask": "Suppresses Slow Stamina Recovery",
            "stamina_pool_mask": "Suppresses Reduced Stamina",
            "wheezing_audio_mask": "Suppresses Wheezing",
            "blood_vision_mask": "Suppresses Blood Vision",
            "hurt_locomotion_mask": "Suppresses Limping",
            "traversal_lock_mask": "Suppresses Climbing Lock",
            "traversal_lock_prone_mask": "Suppresses Forced Prone",
            "pain_grunt_mask": "Suppresses Pain Sounds",
            "arms_lock_mask": "Suppresses Arm Lock",
            "muffled_audio_injury_mask": "Suppresses Muffled Hearing",
            "drunk_locomotion_mask": "Suppresses Drunk Walking",
            "drunk_manoeuvring_mask": "Suppresses Drunk Flying",
            "double_vision_mask": "Suppresses Double Vision",
            "blurred_vision_mask": "Suppresses Blurred Vision"
          },
          "fields": {
            "alpha": "Damage per Shot",
            "dps": "Damage per Second",
            "damagePerSecond": "Beam Damage per Second",
            "fireRate": "Rate of Fire",
            "shots": "Rounds per Burst",
            "cooldown": "Cooldown",
            "pellets": "Pellets",
            "chargeTime": "Charge Time",
            "fullChargeDamage": "Full Charge Damage",
            "unchargedAlpha": "Uncharged Shot",
            "unchargedDps": "Uncharged DPS",
            "fullDamageRange": "Full Damage Range",
            "zeroDamageRange": "Maximum Range",
            "chargeUpTime": "Spin-up Time",
            "spread": "Spread",
            "heatPerShot": "Heat per Shot",
            "heatPerSecond": "Heat per Second",
            "timeToOverheat": "Time to Overheat",
            "shotsToOverheat": "Shots to Overheat",
            "damage": "Damage",
            "explosionDamage": "Blast Damage",
            "blastRadius": "Blast Radius",
            "damageDrop": "Damage Falloff",
            "speed": "Projectile Speed",
            "range": "Range",
            "target": "Target",
            "optimalRange": "Optimal Range",
            "sensorRange": "Sensor Range",
            "doseRate": "Dose Rate (per second)",
            "power": "Power",
            "minForce": "Minimum Force",
            "maxForce": "Maximum Force",
            "minDistance": "Minimum Distance",
            "maxDistance": "Maximum Distance",
            "fullStrengthDistance": "Full Strength Distance",
            "maxAngle": "Maximum Angle",
            "maxVolume": "Maximum Volume",
            "maxSpeed": "Maximum Speed",
            "healthRate": "Repair Rate (per second)",
            "damageMapRate": "Surface Repair Rate",
            "materialEfficiency": "Material Efficiency",
            "rampUpTime": "Ramp-up Time",
            "resourceRate": "Transfer Rate",
            "minPrime": "Minimum Prime",
            "maxPrime": "Maximum Prime",
            "primeTime": "Prime Time",
            "overloadDuration": "Overload Duration",
            "coneAngle": "Spray Angle",
            "maxRadius": "Spray Radius",
            "magazineSize": "Rounds",
            "reserve": "Spare Magazines",
            "capacity": "Capacity",
            "regenPerSecond": "Recharge per Second",
            "regenCooldown": "Recharge Delay",
            "overheatAt": "Overheats At",
            "coolingPerSecond": "Cooling per Second",
            "coolingDelay": "Cooling Delay",
            "overheatFixTime": "Overheat Lockout",
            "fuse": "Fuse",
            "trigger": "Trigger",
            "triggerRadius": "Trigger Radius",
            "warningRadius": "Warning Radius",
            "laserLength": "Tripwire Length",
            "projectileSpeed": "Projectile Speed",
            "heat": "Heat",
            "spreadMin": "Minimum Spread",
            "spreadMax": "Maximum Spread",
            "spreadFirstAttack": "Initial Spread",
            "secondZoom": "Second Zoom Level",
            "zoomTime": "Time to Aim",
            "spreadGrowth": "Spread Growth",
            "spreadRecovery": "Spread Recovery",
            "recoilYaw": "Horizontal Recoil",
            "recoilPitch": "Vertical Recoil",
            "soundRadius": "Sound Radius",
            "zoom": "Zoom",
            "charges": "Charges",
            "health": "Health Restored",
            "effects": "Effects"
          }
        },
        "availability": {
          "retired": "Prices are tracked for the build the catalogue is on, and this item is not in it.",
          "craftedOnly": "No terminal sells this — it is made from the recipe below.",
          "none": "No terminal buys or sells this."
        },
        "stats": {
          "damageReduction": "Damage Reduction",
          "temperatureRating": "Temperature Rating",
          "radiationProtection": "Radiation Protection",
          "radiationScrubRate": "Radiation Scrub Rate",
          "gForceTolerance": "G-Force Tolerance",
          "carryingCapacity": "Carrying Capacity",
          "magazineSize": "Magazine Size",
          "alphaDamage": "Damage per Shot",
          "dps": "Damage per Second",
          "blastDamage": "Blast Damage",
          "blastRadius": "Blast Radius",
          "meleeDamage": "Melee Damage",
          "tractorForce": "Tractor Force",
          "tractorRange": "Tractor Range",
          "healRange": "Healing Range",
          "doseRate": "Dose Rate (per second)",
          "repairRate": "Repair Rate (per second)",
          "salvageRate": "Salvage Rate (per second)",
          "miningPower": "Mining Power",
          "extinguishRange": "Extinguishing Range",
          "healthRestored": "Health Restored",
          "instability": "Instability",
          "resistance": "Resistance",
          "clusterFactor": "Cluster Factor",
          "optimalChargeWindow": "Optimal Charge Window",
          "zoom": "Zoom",
          "recoilChange": "Recoil",
          "spreadChange": "Spread",
          "damageChange": "Damage",
          "fireRateChange": "Rate of Fire",
          "soundRadiusChange": "Sound Radius",
          "rateOfFire": "Rate of Fire",
          "range": "Effective Range",
          "weaponClass": "Weapon Class",
          "coreCompatibility": "Core Compatibility",
          "backpackCompatibility": "Backpack Compatibility",
          "volume": "Volume"
        },
        "sorts": {
          "damageReduction": "Damage Reduction",
          "radiationProtection": "Radiation Protection",
          "gForceTolerance": "G-Force Tolerance",
          "rateOfFire": "Rate of Fire",
          "range": "Range",
          "storage": "Capacity",
          "alphaDamage": "Damage per Shot",
          "dps": "DPS",
          "volume": "Volume"
        }
      },
      "notifications": {
        "inbox": "Inbox",
        "archive": "Archive",
        "unreadOnly": "Unread only",
        "status": "Status",
        "type": "Type",
        "selectPrompt": "Select a notification to read it",
        "noBody": "This notification carries no further details.",
        "archivesOn": "Moves to the archive",
        "deletesOn": "Deleted"
      },
      "unlistedModel": {
        "linkHint": "Which ship in the catalogue is %{identifier}? The suggestion comes from the export and may be wrong."
      },
      "slug": "Slug",
      "inventories": {
        "source": "Source",
        "sources": {
          "vehicle": "Ship",
          "handMade": "Made by hand"
        }
      },
      "inventoryItems": {
        "name": "Name",
        "category": "Category",
        "entryType": "Entry",
        "quantity": "Quantity",
        "quality": "Quality",
        "notes": "Notes",
        "itemType": "Catalogue",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Ammunition",
          "consumable": "Consumable",
          "other": "Other",
          "armor": "Armor",
          "clothing": "Clothing",
          "tool": "Tool",
          "container": "Container"
        },
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "units": {
          "scu": "SCU",
          "units": "units"
        }
      },
      "shipHistory": {
        "sales": "Sale History",
        "salesCount": "Recorded sales",
        "lastSale": "Last sale",
        "averageGap": "Average gap",
        "days": "%{count} days",
        "ongoing": "Ongoing",
        "priceHistory": "Pledge Price History",
        "firstPriced": "First priced",
        "priceRemoved": "Price removed",
        "wishlist": "Wishlist Additions per Month",
        "patchChanges": "Patch Changes",
        "notRecordedYet": "Only recorded from the day this started, so a ship can have none yet."
      },
      "buildCompare": {
        "from": "From build",
        "to": "To build",
        "appeared": "Appeared",
        "vanished": "Vanished",
        "changed": "Changed",
        "notRecorded": "Not recorded for one of these builds.",
        "needsTwoBuilds": "Only one build is on record, so there is nothing to compare it with.",
        "pickTwoBuilds": "Pick two different builds.",
        "failed": "Could not compare these two builds.",
        "andMore": "and %{count} more",
        "catalogues": {
          "components": "Components",
          "equipment": "Equipment",
          "commodities": "Commodities",
          "models": "Ships"
        }
      },
      "dockAccess": {
        "ramp": "Ramp",
        "lift": "Lift",
        "tractor_beam": "Tractor Beam"
      },
      "dockTypes": {
        "vehiclepad": "Vehicle pad",
        "garage": "Garage",
        "landingpad": "Landing pad",
        "dockingport": "Docking port",
        "hangar": "Hangar",
        "cargogrid": "Cargo grid"
      },
      "payouts": {
        "currency": "Currency",
        "archived": "Archived",
        "activeTours": "Current",
        "amount": "Amount",
        "description": "Description",
        "entryType": "Type",
        "expense": "Spent",
        "income": "Earned",
        "participant": "Who",
        "notes": "Notes",
        "occurredAt": "When",
        "paid": "Spent",
        "held": "Holding",
        "share": "Share",
        "net": "Balance",
        "profit": "Profit",
        "totalIncome": "Earned",
        "totalExpenses": "Spent",
        "guest": "Guest",
        "username": "Username",
        "name": "Name",
        "sends": "sends",
        "receives": "receives",
        "settled": "Settled",
        "open": "Open",
        "owes": "owes",
        "isOwed": "is owed",
        "even": "settled up",
        "title": "Title",
        "fleet": "Fleet",
        "startsAt": "Starts at",
        "inviteLink": "Invite link",
        "participants": "People",
        "weight": "Weight",
        "shares": "shares",
        "customWeight": "Any weight",
        "preview": "Preview · moves until you settle",
        "joinRequestPending": "Request pending",
        "payer": "Payer",
        "declineReason": "Reason",
        "review": {
          "pending": "Waiting for review",
          "approved": "Approved",
          "declined": "Declined"
        }
      },
      "shipSizes": {
        "extra_extra_small": "Snubcraft (XXS)",
        "extra_small": "Extra Small (XS)",
        "small": "Small (S)",
        "medium": "Medium (M)",
        "large": "Large (L)",
        "extra_large": "Extra Large (XL)",
        "capital": "Capital (C)"
      },
      "relationships": {
        "party": "Name",
        "since": "Since",
        "tabs": {
          "accepted": "Active",
          "incoming": "Incoming",
          "outgoing": "Sent",
          "ignored": "Ignored"
        },
        "user": {
          "handle": "Username"
        },
        "fleet": {
          "handle": "Fleet slug"
        },
        "requested": "Request sent",
        "friend": "Friends"
      },
      "blueprint": {
        "anyGrade": "Any grade",
        "crafter": {
          "title": "Craft · %{name}",
          "recipe": "Recipe %{number}",
          "noRecipe": "No recipe for this item in the current build."
        },
        "name": "Name",
        "craftTime": "Craft time",
        "slots": "Slots",
        "materials": "Materials",
        "quality": "Quality",
        "missionSlots": {
          "location": "location",
          "objects": "objects",
          "target": "target",
          "ship": "ship",
          "cargo": "cargo",
          "rank": "rank",
          "danger": "danger",
          "contract": "contract",
          "other": "varies"
        },
        "missionSlotsHint": "Words in ‹angle brackets› are filled in by the game when the contract is offered.",
        "atNeutral": "%{value} at Q500",
        "whatYouGet": "What you get",
        "fromSlots": "%{count} slots",
        "factorOnly": "factor only — no catalogue figure for this stat",
        "heldIn": "in",
        "heldOn": "on",
        "fromHangar": "Hangar",
        "makes": "Makes",
        "makesA": "Crafting recipe · makes a",
        "makesUnknown": "Crafting recipe · makes something no catalogue here carries",
        "retired": "Retired",
        "minQuality": "Min %{quality}",
        "belowGate": "Below this slot's gate — material under %{quality} cannot go in here.",
        "unvalued": "affected — the game states no figures",
        "noStats": "This slot moves no stats — the material only has to be there.",
        "noMaterials": "The game files list no materials for this recipe.",
        "setEverySlot": "Set every slot",
        "qualityAll": "all slots at %{quality}",
        "qualityRange": "%{from}–%{to} across the slots",
        "anyOf": "Any %{count} of these %{total}",
        "scu": "%{amount} SCU",
        "pieces": "%{count}×",
        "whereItDrops": "Where it drops",
        "fleetOwners": "Who can craft it",
        "ownedByCount": "%{count} hold it",
        "sourceSummary": "%{count} sources · %{orgs} orgs",
        "unattributed": "Unattributed",
        "minPoints": "From %{points} points",
        "limitedEvent": "Limited-time event",
        "viewMission": "View mission",
        "eventHint": "Event rewards drop only while CIG runs the event. The game files keep its reward track between runs, so they cannot say whether it is live right now.",
        "noKnownSource": "No known source",
        "noSourceLead": "No mission or scenario hands this recipe out.",
        "noSourceBody": "The game files place it in no reward pool, so there is nothing to point you at.",
        "empty": "No blueprints match.",
        "craftableTypes": {
          "Component": "Component",
          "Equipment": "Equipment",
          "Commodity": "Commodity"
        },
        "alignments": {
          "lawful": "Lawful",
          "neutral": "Neutral",
          "outlaw": "Outlaw"
        },
        "kinds": {
          "contract": "Contract",
          "scenario": "Event"
        },
        "duration": {
          "hours": "%{count}h",
          "minutes": "%{count}m",
          "seconds": "%{count}s"
        }
      },
      "gameMission": {
        "locationNamedInText": "named in the briefing",
        "locations": "Where it takes place",
        "locationKinds": {
          "surface": "On a planet or moon",
          "space": "In space",
          "mixed": "Planet, moon or space",
          "unknown": "Location unknown"
        },
        "location": "Location",
        "cannotLand": {
          "surface": "%{ship} can't land: this contract is on a planet or moon",
          "mixed": "May take %{ship} to a planet or moon, where it can't land"
        },
        "calculatedInGame": "Set in game",
        "blueprints": "Blueprints",
        "name": "Name",
        "org": "Offered by",
        "system": "System",
        "offeredBy": "Offered by",
        "offeredByUnknown": "No stated contractor",
        "standing": "Standing",
        "kind": "Kind",
        "kinds": {
          "career": "Career",
          "contract": "One-off"
        },
        "difficulty": "Difficulty",
        "difficultyAxes": {
          "mechanicalSkill": "Mechanical skill",
          "mentalLoad": "Mental load",
          "riskOfLoss": "Risk of loss",
          "gameKnowledge": "Game knowledge"
        },
        "alignments": {
          "lawful": "Lawful",
          "neutral": "Neutral",
          "outlaw": "Outlaw"
        },
        "rewards": "Rewards",
        "rewardKinds": {
          "blueprint": "Blueprints",
          "reputation": "Reputation",
          "item": "Items",
          "badge": "Badge",
          "currency": "Payout"
        },
        "oneOfASet": "one of a set",
        "briefing": "Briefing",
        "templatedNote": "The game fills the marked parts in when it hands the mission out.",
        "payoutNote": "The game works the payout out when the mission is generated, so the files state one for only a handful of contracts.",
        "noRewards": "The files state no reward for this one.",
        "handIns": "Hand-ins",
        "handInsChoice": "One of these",
        "buyIn": "Buy-in",
        "timeToComplete": "Time",
        "minutes": "%{time} min",
        "offeredAt": "Offered at",
        "availability": {
          "orHigher": "%{standing} or higher",
          "reputationAny": "Any standing with %{org}",
          "onceOnly": "Once only",
          "thisMission": "this mission",
          "title": "Availability",
          "onePerPlayer": "One at a time per player",
          "perPlayer": "Up to %{count} at a time per player",
          "respawn": "Offered again after %{time} min",
          "respawnVaried": "Offered again after %{time} ± %{variation} min",
          "crimeStat": "CrimeStat %{min} – %{max}",
          "reputation": "%{band} with %{org}",
          "reputationExcluded": "Not %{band} with %{org}",
          "completeFirst": "Complete first",
          "completeCount": "Complete %{count} of",
          "completeUnlisted": "Complete %{count} missions not in the catalogue",
          "excluded": "Not once you have completed"
        },
        "unreleased": "Not in release",
        "retired": "Retired"
      },
      "fleetDirectory": {
        "name": "Fleets",
        "memberCount": "Members",
        "createdAt": "Newest",
        "language": "Language",
        "recruiting": "Recruiting",
        "notRecruiting": "Not recruiting",
        "roleplay": "Role play",
        "rsiSid": "SID %{sid}"
      },
      "tour": {
        "step": "Step %{current} of %{total}"
      },
      "vehiclePlaque": {
        "style": "Style",
        "styles": {
          "brass": "Brass",
          "hud": "Fleetyards HUD",
          "gunmetal": "Gunmetal",
          "blueprint": "Shipyard blueprint",
          "salvage": "Riveted salvage",
          "glass": "Frosted glass",
          "carbon": "Carbon & signal red",
          "walnut": "Walnut & brass",
          "neon": "Pyro neon",
          "manufacturer": "Manufacturer style"
        },
        "captain": "Captain",
        "captainInfo": "Leave empty to name yourself as you show on your public hangar.",
        "registry": "Registry",
        "operationsGroup": "Operations crew",
        "title": "Dedication plaque",
        "dedication": "Dedication",
        "dedicationVerse": "Dedication verse",
        "dedicationVerseInfo": "Optional. A few lines of verse or a blessing, shown when someone hovers over or taps the dedication.",
        "translated": "Translate the plaque",
        "translatedInfo": "Prints the plaque in the language Fleetyards is set to, for everyone who sees it. Off, it reads in English, as the plaques in the game do.",
        "translatedInto": "Printed in %{language} for everyone who sees it. Turned off, it reads in English.",
        "launchedOn": "Launch date",
        "launchPort": "Launch port",
        "affiliation": "Affiliation"
      },
      "vehicleOverview": {
        "picture": "Picture",
        "pictureInfo": "Shown instead of the stock render, also in your public hangar and in fleets you share this ship with.",
        "ownPicture": "Your picture",
        "serial": "Serial %{serial}",
        "since": "In hangar since %{date}",
        "logSummary": "%{count} entries · %{public} public",
        "cargoFill": "%{stowed} of %{capacity} SCU stowed",
        "cargoStowed": "%{stowed} SCU stowed",
        "cargoMeter": "Hold fill",
        "configuration": "Configuration",
        "noPaint": "Standard livery",
        "ownedPaints": "Your paints",
        "availablePaints": "Paints",
        "ownedPaintsCount": {
          "one": "%{count} paint",
          "other": "%{count} paints"
        },
        "visibility": "Visibility",
        "showPublic": "Show in my public hangar",
        "showName": "Show the name",
        "fleets": "Serving with",
        "status": "Status",
        "searchPaints": "Search paints",
        "location": "Location",
        "noLocation": "Not set",
        "noGroups": "No groups",
        "pictureUpload": "Upload",
        "pictureGallery": "Gallery",
        "stockPicture": "Standard picture",
        "waysToGetIt": "Ways to get it"
      },
      "vehicleLog": {
        "entries": "log entries",
        "title": "Title",
        "loggedAt": "Date",
        "loggedAtPlaceholder": "Now",
        "body": "Entry",
        "public": "Show in my public hangar",
        "publicShort": "Public",
        "publicByDefault": "New entries are public",
        "filters": {
          "all": "All",
          "public": "Public",
          "private": "Private"
        },
        "entryCount": {
          "one": "%{count} entry",
          "other": "%{count} entries"
        },
        "privateShort": "Private",
        "stats": "The log",
        "statsEntries": "Entries",
        "statsPublic": "Public",
        "statsSince": "Since"
      },
      "vehicleEdit": {
        "tabs": {
          "general": "General",
          "visibility": "Visibility",
          "notifications": "Notifications",
          "names": "Names",
          "groups": "Groups",
          "picture": "Picture"
        }
      },
      "vehicleLoadout": {
        "tabs": {
          "paints": "Paints",
          "modules": "Modules",
          "upgrades": "Add-ons",
          "weapons": "Weapons",
          "missiles": "Missiles",
          "shields": "Shield generators",
          "powerPlants": "Power plants",
          "coolers": "Coolers",
          "quantumDrives": "Quantum drives",
          "radar": "Radar",
          "lifeSupport": "Life support",
          "flightBlades": "Flight blades",
          "auxiliary": "Auxiliary"
        },
        "comingSoon": "Coming soon",
        "ownedModules": "Modules you own",
        "nothingFitted": "Nothing fitted",
        "refused": {
          "title": "No longer fits since a game update",
          "removedOnSave": "Saving takes these out of the loadout.",
          "editToReplace": "Edit the loadout to replace them.",
          "badge": "No longer fits",
          "reasons": {
            "slot_unknown": "the ship no longer has this slot",
            "parent_not_fitted": "what it sat in is gone",
            "module_not_in_slot": "the module no longer fits this slot",
            "component_not_in_slot": "no longer fits this slot",
            "slot_not_editable": "the ship now fixes this slot",
            "nothing_to_empty": "the slot no longer holds a part to take out"
          }
        },
        "againstStock": "Changes from the stock ship",
        "crafted": "Crafted",
        "craftedPart": "%{name} (crafted)",
        "fitted": "Fitted",
        "owned": "Owned",
        "noSlots": "Nothing on this ship can be fitted here yet",
        "unavailableModule": "Module no longer available",
        "noFigureChange": "Changes none of the ship's figures",
        "loadoutName": "Loadout name",
        "linkBuild": "Link to a build planned elsewhere",
        "stock": "Stock",
        "notFlightReady": "Loadouts are only available for flight-ready ships",
        "slots": {
          "default": "Module slot",
          "front": "Front module slot",
          "rear": "Rear module slot",
          "left": "Left module slot",
          "right": "Right module slot"
        },
        "unavailable": {
          "modules": "This ship takes no modules",
          "upgrades": "There are no add-ons for this ship"
        },
        "none": "None"
      },
      "loadoutPicker": {
        "emptySocket": "Empty",
        "search": "Search",
        "owned": "Owned",
        "stock": "Stock",
        "manufacturer": "Manufacturer",
        "sortName": "Name",
        "count": "%{count} of %{total}",
        "total": {
          "one": "%{count} option",
          "other": "%{count} options"
        },
        "reset": "Reset filters",
        "leaveEmpty": "Leave empty",
        "type": "Type",
        "fixedByShip": "Fixed by the ship",
        "noOtherPart": "No other part fits",
        "changed": "Changed",
        "noMatches": "Nothing matches",
        "close": "Close"
      },
      "plaqueTool": {
        "ship": "Ship",
        "name": "Ship name",
        "vehicle": "Your ship",
        "hasPlaque": "has a plaque",
        "captainInfo": "The name the plaque gives as the ship's captain."
      }
    }
  }
}
